import React from 'react';
import { Button, CardTitle, Container, Table } from 'reactstrap';
// LegalNotice
const LegalNotice = () => {
  return (
    <Container fluid='md'>
      <CardTitle>
        <h1>Legal Notice</h1>
      </CardTitle>
      <Button
        style={{
          position: 'fixed',
          top: '100px',
          right: '20px',
        }}
        onClick={() => window.history.back()}
      >
        Back
      </Button>
      <br />
      <h2>General Data Protection Regulation (GDPR) Notice</h2>
      <p>
        Every change in a project creates an entry in the changelog, which
        contains the username and a time stamp. This log serves the traceability
        of changes in the project and can be viewed by every participant of the
        project. It is saved during the whole existance of the project in ISAT.
      </p>
      <p>
        Additionally, Security-relevant events (e.g. logins or activities that
        require admin rights) are stored in a separate security log that is only
        accessible to admins. The log entries contain the username, IP adress
        and a time stamp. These entries are only used to identify unintentional
        system behavior or possible intrusion into the system from outside. The
        entries of the security log must be deleted manually. There is no
        automatic deletion after a fixed period of time.
      </p>
      <br />
      <h2>License Usage</h2>
      <Table bordered>
        <tr>
          <th>Module Name</th>
          <th>Version</th>
          <th>License Full Name</th>
          <th>License Text</th>
          <th>Repository Link</th>
        </tr>
        {/* Front End Licenses */}
        <tr>
          <td>@babel/code-frame</td>
          <td>7.8.3</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>
            https://github.com/babel/babel/tree/master/packages/babel-code-frame
          </td>
        </tr>
        <tr>
          <td>@babel/helper-module-imports</td>
          <td>7.8.3</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>
            https://github.com/babel/babel/tree/master/packages/babel-helper-module-imports
          </td>
        </tr>
        <tr>
          <td>@babel/helper-validator-identifier</td>
          <td>7.9.5</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>
            https://github.com/babel/babel/tree/master/packages/babel-helper-validator-identifier
          </td>
        </tr>
        <tr>
          <td>@babel/highlight</td>
          <td>7.9.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>
            https://github.com/babel/babel/tree/master/packages/babel-highlight
          </td>
        </tr>
        <tr>
          <td>@babel/runtime</td>
          <td>7.9.6</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/babel/babel/tree/v7.9.6</td>
        </tr>
        <tr>
          <td>@babel/types</td>
          <td>7.9.6</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>
            https://github.com/babel/babel/tree/master/packages/babel-types
          </td>
        </tr>
        <tr>
          <td>@emotion/cache</td>
          <td>10.0.29</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/cache
          </td>
        </tr>
        <tr>
          <td>@emotion/core</td>
          <td>10.0.28</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/core
          </td>
        </tr>
        <tr>
          <td>@emotion/css</td>
          <td>10.0.27</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/css
          </td>
        </tr>
        <tr>
          <td>@emotion/hash</td>
          <td>0.8.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/hash
          </td>
        </tr>
        <tr>
          <td>@emotion/memoize</td>
          <td>0.7.4</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/memoize
          </td>
        </tr>
        <tr>
          <td>@emotion/serialize</td>
          <td>0.11.16</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/serialize
          </td>
        </tr>
        <tr>
          <td>@emotion/sheet</td>
          <td>0.9.4</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/sheet
          </td>
        </tr>
        <tr>
          <td>@emotion/stylis</td>
          <td>0.8.5</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/stylis
          </td>
        </tr>
        <tr>
          <td>@emotion/unitless</td>
          <td>0.7.5</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/unitless
          </td>
        </tr>
        <tr>
          <td>@emotion/utils</td>
          <td>0.11.3</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/utils
          </td>
        </tr>
        <tr>
          <td>@emotion/weak-memoize</td>
          <td>0.2.5</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/master/packages/weak-memoize
          </td>
        </tr>
        <tr>
          <td>@fortawesome/fontawesome-common-types</td>
          <td>0.2.28</td>
          <td>Custom License</td>
          <td>
            Font Awesome Free License ------------------------- Font Awesome
            Free is free, open source, and GPL friendly. You can use it for
            commercial projects, open source projects, or really almost whatever
            you want. Full Font Awesome Free license:
            https://fontawesome.com/license/free. # Icons: CC BY 4.0 License
            (https://creativecommons.org/licenses/by/4.0/) In the Font Awesome
            Free download, the CC BY 4.0 license applies to all icons packaged
            as SVG and JS file types. # Fonts: SIL OFL 1.1 License
            (https://scripts.sil.org/OFL) In the Font Awesome Free download, the
            SIL OFL license applies to all icons packaged as web and desktop
            font files. # Code: MIT License
            (https://opensource.org/licenses/MIT) In the Font Awesome Free
            download, the MIT license applies to all non-font and non-icon
            files. # Attribution Attribution is required by MIT, SIL OFL, and CC
            BY licenses. Downloaded Font Awesome Free files already contain
            embedded comments with sufficient attribution, so you shouldn't need
            to do anything additional when using these files normally. We've
            kept attribution comments terse, so we ask that you do not actively
            work to remove them from files, especially code. They're a great way
            for folks to learn about Font Awesome. # Brand Icons All brand icons
            are trademarks of their respective owners. The use of these
            trademarks does not indicate endorsement of the trademark holder by
            Font Awesome, nor vice versa. **Please do not use brand logos for
            any purpose except to represent the company, product, or service to
            which they refer.**
          </td>
          <td>https://github.com/FortAwesome/Font-Awesome</td>
        </tr>
        <tr>
          <td>@fortawesome/fontawesome-common-types</td>
          <td>0.2.28</td>
          <td>Creative Commons Attribution 4.0 International</td>
          <td>
            Creative Commons Attribution 4.0 International Creative Commons
            Corporation ("Creative Commons") is not a law firm and does not
            provide legal services or legal advice. Distribution of Creative
            Commons public licenses does not create a lawyer-client or other
            relationship. Creative Commons makes its licenses and related
            information available on an "as-is" basis. Creative Commons gives no
            warranties regarding its licenses, any material licensed under their
            terms and conditions, or any related information. Creative Commons
            disclaims all liability for damages resulting from their use to the
            fullest extent possible. Using Creative Commons Public Licenses
            Creative Commons public licenses provide a standard set of terms and
            conditions that creators and other rights holders may use to share
            original works of authorship and other material subject to copyright
            and certain other rights specified in the public license below. The
            following considerations are for informational purposes only, are
            not exhaustive, and do not form part of our licenses. Considerations
            for licensors: Our public licenses are intended for use by those
            authorized to give the public permission to use material in ways
            otherwise restricted by copyright and certain other rights. Our
            licenses are irrevocable. Licensors should read and understand the
            terms and conditions of the license they choose before applying it.
            Licensors should also secure all rights necessary before applying
            our licenses so that the public can reuse the material as expected.
            Licensors should clearly mark any material not subject to the
            license. This includes other CC-licensed material, or material used
            under an exception or limitation to copyright. More considerations
            for licensors :
            wiki.creativecommons.org/Considerations_for_licensors Considerations
            for the public: By using one of our public licenses, a licensor
            grants the public permission to use the licensed material under
            specified terms and conditions. If the licensor's permission is not
            necessary for any reason–for example, because of any applicable
            exception or limitation to copyright–then that use is not regulated
            by the license. Our licenses grant only permissions under copyright
            and certain other rights that a licensor has authority to grant. Use
            of the licensed material may still be restricted for other reasons,
            including because others have copyright or other rights in the
            material. A licensor may make special requests, such as asking that
            all changes be marked or described. Although not required by our
            licenses, you are encouraged to respect those requests where
            reasonable. More considerations for the public :
            wiki.creativecommons.org/Considerations_for_licensees Creative
            Commons Attribution 4.0 International Public License By exercising
            the Licensed Rights (defined below), You accept and agree to be
            bound by the terms and conditions of this Creative Commons
            Attribution 4.0 International Public License ("Public License"). To
            the extent this Public License may be interpreted as a contract, You
            are granted the Licensed Rights in consideration of Your acceptance
            of these terms and conditions, and the Licensor grants You such
            rights in consideration of benefits the Licensor receives from
            making the Licensed Material available under these terms and
            conditions. Section 1 – Definitions. a. Adapted Material means
            material subject to Copyright and Similar Rights that is derived
            from or based upon the Licensed Material and in which the Licensed
            Material is translated, altered, arranged, transformed, or otherwise
            modified in a manner requiring permission under the Copyright and
            Similar Rights held by the Licensor. For purposes of this Public
            License, where the Licensed Material is a musical work, performance,
            or sound recording, Adapted Material is always produced where the
            Licensed Material is synched in timed relation with a moving image.
            b. Adapter's License means the license You apply to Your Copyright
            and Similar Rights in Your contributions to Adapted Material in
            accordance with the terms and conditions of this Public License. c.
            Copyright and Similar Rights means copyright and/or similar rights
            closely related to copyright including, without limitation,
            performance, broadcast, sound recording, and Sui Generis Database
            Rights, without regard to how the rights are labeled or categorized.
            For purposes of this Public License, the rights specified in Section
            2(b)(1)-(2) are not Copyright and Similar Rights. d. Effective
            Technological Measures means those measures that, in the absence of
            proper authority, may not be circumvented under laws fulfilling
            obligations under Article 11 of the WIPO Copyright Treaty adopted on
            December 20, 1996, and/or similar international agreements. e.
            Exceptions and Limitations means fair use, fair dealing, and/or any
            other exception or limitation to Copyright and Similar Rights that
            applies to Your use of the Licensed Material. f. Licensed Material
            means the artistic or literary work, database, or other material to
            which the Licensor applied this Public License. g. Licensed Rights
            means the rights granted to You subject to the terms and conditions
            of this Public License, which are limited to all Copyright and
            Similar Rights that apply to Your use of the Licensed Material and
            that the Licensor has authority to license. h. Licensor means the
            individual(s) or entity(ies) granting rights under this Public
            License. i. Share means to provide material to the public by any
            means or process that requires permission under the Licensed Rights,
            such as reproduction, public display, public performance,
            distribution, dissemination, communication, or importation, and to
            make material available to the public including in ways that members
            of the public may access the material from a place and at a time
            individually chosen by them. j. Sui Generis Database Rights means
            rights other than copyright resulting from Directive 96/9/EC of the
            European Parliament and of the Council of 11 March 1996 on the legal
            protection of databases, as amended and/or succeeded, as well as
            other essentially equivalent rights anywhere in the world. k. You
            means the individual or entity exercising the Licensed Rights under
            this Public License. Your has a corresponding meaning. Section 2 –
            Scope. a. License grant. 1. Subject to the terms and conditions of
            this Public License, the Licensor hereby grants You a worldwide,
            royalty-free, non-sublicensable, non-exclusive, irrevocable license
            to exercise the Licensed Rights in the Licensed Material to: A.
            reproduce and Share the Licensed Material, in whole or in part; and
            B. produce, reproduce, and Share Adapted Material. 2. Exceptions and
            Limitations. For the avoidance of doubt, where Exceptions and
            Limitations apply to Your use, this Public License does not apply,
            and You do not need to comply with its terms and conditions. 3.
            Term. The term of this Public License is specified in Section 6(a).
            4. Media and formats; technical modifications allowed. The Licensor
            authorizes You to exercise the Licensed Rights in all media and
            formats whether now known or hereafter created, and to make
            technical modifications necessary to do so. The Licensor waives
            and/or agrees not to assert any right or authority to forbid You
            from making technical modifications necessary to exercise the
            Licensed Rights, including technical modifications necessary to
            circumvent Effective Technological Measures. For purposes of this
            Public License, simply making modifications authorized by this
            Section 2(a)(4) never produces Adapted Material. 5. Downstream
            recipients. A. Offer from the Licensor – Licensed Material. Every
            recipient of the Licensed Material automatically receives an offer
            from the Licensor to exercise the Licensed Rights under the terms
            and conditions of this Public License. B. No downstream
            restrictions. You may not offer or impose any additional or
            different terms or conditions on, or apply any Effective
            Technological Measures to, the Licensed Material if doing so
            restricts exercise of the Licensed Rights by any recipient of the
            Licensed Material. 6. No endorsement. Nothing in this Public License
            constitutes or may be construed as permission to assert or imply
            that You are, or that Your use of the Licensed Material is,
            connected with, or sponsored, endorsed, or granted official status
            by, the Licensor or others designated to receive attribution as
            provided in Section 3(a)(1)(A)(i). b. Other rights. 1. Moral rights,
            such as the right of integrity, are not licensed under this Public
            License, nor are publicity, privacy, and/or other similar
            personality rights; however, to the extent possible, the Licensor
            waives and/or agrees not to assert any such rights held by the
            Licensor to the limited extent necessary to allow You to exercise
            the Licensed Rights, but not otherwise. 2. Patent and trademark
            rights are not licensed under this Public License. 3. To the extent
            possible, the Licensor waives any right to collect royalties from
            You for the exercise of the Licensed Rights, whether directly or
            through a collecting society under any voluntary or waivable
            statutory or compulsory licensing scheme. In all other cases the
            Licensor expressly reserves any right to collect such royalties.
            Section 3 – License Conditions. Your exercise of the Licensed Rights
            is expressly made subject to the following conditions. a.
            Attribution. 1. If You Share the Licensed Material (including in
            modified form), You must: A. retain the following if it is supplied
            by the Licensor with the Licensed Material: i. identification of the
            creator(s) of the Licensed Material and any others designated to
            receive attribution, in any reasonable manner requested by the
            Licensor (including by pseudonym if designated); ii. a copyright
            notice; iii. a notice that refers to this Public License; iv. a
            notice that refers to the disclaimer of warranties; v. a URI or
            hyperlink to the Licensed Material to the extent reasonably
            practicable; B. indicate if You modified the Licensed Material and
            retain an indication of any previous modifications; and C. indicate
            the Licensed Material is licensed under this Public License, and
            include the text of, or the URI or hyperlink to, this Public
            License. 2. You may satisfy the conditions in Section 3(a)(1) in any
            reasonable manner based on the medium, means, and context in which
            You Share the Licensed Material. For example, it may be reasonable
            to satisfy the conditions by providing a URI or hyperlink to a
            resource that includes the required information. 3. If requested by
            the Licensor, You must remove any of the information required by
            Section 3(a)(1)(A) to the extent reasonably practicable. 4. If You
            Share Adapted Material You produce, the Adapter's License You apply
            must not prevent recipients of the Adapted Material from complying
            with this Public License. Section 4 – Sui Generis Database Rights.
            Where the Licensed Rights include Sui Generis Database Rights that
            apply to Your use of the Licensed Material: a. for the avoidance of
            doubt, Section 2(a)(1) grants You the right to extract, reuse,
            reproduce, and Share all or a substantial portion of the contents of
            the database; b. if You include all or a substantial portion of the
            database contents in a database in which You have Sui Generis
            Database Rights, then the database in which You have Sui Generis
            Database Rights (but not its individual contents) is Adapted
            Material; and c. You must comply with the conditions in Section 3(a)
            if You Share all or a substantial portion of the contents of the
            database. For the avoidance of doubt, this Section 4 supplements and
            does not replace Your obligations under this Public License where
            the Licensed Rights include other Copyright and Similar Rights.
            Section 5 – Disclaimer of Warranties and Limitation of Liability. a.
            Unless otherwise separately undertaken by the Licensor, to the
            extent possible, the Licensor offers the Licensed Material as-is and
            as-available, and makes no representations or warranties of any kind
            concerning the Licensed Material, whether express, implied,
            statutory, or other. This includes, without limitation, warranties
            of title, merchantability, fitness for a particular purpose,
            non-infringement, absence of latent or other defects, accuracy, or
            the presence or absence of errors, whether or not known or
            discoverable. Where disclaimers of warranties are not allowed in
            full or in part, this disclaimer may not apply to You. b. To the
            extent possible, in no event will the Licensor be liable to You on
            any legal theory (including, without limitation, negligence) or
            otherwise for any direct, special, indirect, incidental,
            consequential, punitive, exemplary, or other losses, costs,
            expenses, or damages arising out of this Public License or use of
            the Licensed Material, even if the Licensor has been advised of the
            possibility of such losses, costs, expenses, or damages. Where a
            limitation of liability is not allowed in full or in part, this
            limitation may not apply to You. c. The disclaimer of warranties and
            limitation of liability provided above shall be interpreted in a
            manner that, to the extent possible, most closely approximates an
            absolute disclaimer and waiver of all liability. Section 6 – Term
            and Termination. a. This Public License applies for the term of the
            Copyright and Similar Rights licensed here. However, if You fail to
            comply with this Public License, then Your rights under this Public
            License terminate automatically. b. Where Your right to use the
            Licensed Material has terminated under Section 6(a), it reinstates:
            1. automatically as of the date the violation is cured, provided it
            is cured within 30 days of Your discovery of the violation; or 2.
            upon express reinstatement by the Licensor. c. For the avoidance of
            doubt, this Section 6(b) does not affect any right the Licensor may
            have to seek remedies for Your violations of this Public License. d.
            For the avoidance of doubt, the Licensor may also offer the Licensed
            Material under separate terms or conditions or stop distributing the
            Licensed Material at any time; however, doing so will not terminate
            this Public License. e. Sections 1, 5, 6, 7, and 8 survive
            termination of this Public License. Section 7 – Other Terms and
            Conditions. a. The Licensor shall not be bound by any additional or
            different terms or conditions communicated by You unless expressly
            agreed. b. Any arrangements, understandings, or agreements regarding
            the Licensed Material not stated herein are separate from and
            independent of the terms and conditions of this Public License.
            Section 8 – Interpretation. a. For the avoidance of doubt, this
            Public License does not, and shall not be interpreted to, reduce,
            limit, restrict, or impose conditions on any use of the Licensed
            Material that could lawfully be made without permission under this
            Public License. b. To the extent possible, if any provision of this
            Public License is deemed unenforceable, it shall be automatically
            reformed to the minimum extent necessary to make it enforceable. If
            the provision cannot be reformed, it shall be severed from this
            Public License without affecting the enforceability of the remaining
            terms and conditions. c. No term or condition of this Public License
            will be waived and no failure to comply consented to unless
            expressly agreed to by the Licensor. d. Nothing in this Public
            License constitutes or may be interpreted as a limitation upon, or
            waiver of, any privileges and immunities that apply to the Licensor
            or You, including from the legal processes of any jurisdiction or
            authority. Creative Commons is not a party to its public licenses.
            Notwithstanding, Creative Commons may elect to apply one of its
            public licenses to material it publishes and in those instances will
            be considered the "Licensor." The text of the Creative Commons
            public licenses is dedicated to the public domain under the CC0
            Public Domain Dedication. Except for the limited purpose of
            indicating that material is shared under a Creative Commons public
            license or as otherwise permitted by the Creative Commons policies
            published at creativecommons.org/policies, Creative Commons does not
            authorize the use of the trademark "Creative Commons" or any other
            trademark or logo of Creative Commons without its prior written
            consent including, without limitation, in connection with any
            unauthorized modifications to any of its public licenses or any
            other arrangements, understandings, or agreements concerning use of
            licensed material. For the avoidance of doubt, this paragraph does
            not form part of the public licenses. Creative Commons may be
            contacted at creativecommons.org.
          </td>
          <td>https://creativecommons.org/licenses/by/4.0/</td>
        </tr>
        <tr>
          <td>@fortawesome/fontawesome-svg-core</td>
          <td>1.2.28</td>
          <td>Custom License</td>
          <td>
            Font Awesome Free License ------------------------- Font Awesome
            Free is free, open source, and GPL friendly. You can use it for
            commercial projects, open source projects, or really almost whatever
            you want. Full Font Awesome Free license:
            https://fontawesome.com/license/free. # Icons: CC BY 4.0 License
            (https://creativecommons.org/licenses/by/4.0/) In the Font Awesome
            Free download, the CC BY 4.0 license applies to all icons packaged
            as SVG and JS file types. # Fonts: SIL OFL 1.1 License
            (https://scripts.sil.org/OFL) In the Font Awesome Free download, the
            SIL OFL license applies to all icons packaged as web and desktop
            font files. # Code: MIT License
            (https://opensource.org/licenses/MIT) In the Font Awesome Free
            download, the MIT license applies to all non-font and non-icon
            files. # Attribution Attribution is required by MIT, SIL OFL, and CC
            BY licenses. Downloaded Font Awesome Free files already contain
            embedded comments with sufficient attribution, so you shouldn't need
            to do anything additional when using these files normally. We've
            kept attribution comments terse, so we ask that you do not actively
            work to remove them from files, especially code. They're a great way
            for folks to learn about Font Awesome. # Brand Icons All brand icons
            are trademarks of their respective owners. The use of these
            trademarks does not indicate endorsement of the trademark holder by
            Font Awesome, nor vice versa. **Please do not use brand logos for
            any purpose except to represent the company, product, or service to
            which they refer.**
          </td>
          <td>https://github.com/FortAwesome/Font-Awesome</td>
        </tr>
        <tr>
          <td>@fortawesome/fontawesome-svg-core</td>
          <td>1.2.28</td>
          <td>Creative Commons Attribution 4.0 International</td>
          <td>
            Creative Commons Attribution 4.0 International Creative Commons
            Corporation ("Creative Commons") is not a law firm and does not
            provide legal services or legal advice. Distribution of Creative
            Commons public licenses does not create a lawyer-client or other
            relationship. Creative Commons makes its licenses and related
            information available on an "as-is" basis. Creative Commons gives no
            warranties regarding its licenses, any material licensed under their
            terms and conditions, or any related information. Creative Commons
            disclaims all liability for damages resulting from their use to the
            fullest extent possible. Using Creative Commons Public Licenses
            Creative Commons public licenses provide a standard set of terms and
            conditions that creators and other rights holders may use to share
            original works of authorship and other material subject to copyright
            and certain other rights specified in the public license below. The
            following considerations are for informational purposes only, are
            not exhaustive, and do not form part of our licenses. Considerations
            for licensors: Our public licenses are intended for use by those
            authorized to give the public permission to use material in ways
            otherwise restricted by copyright and certain other rights. Our
            licenses are irrevocable. Licensors should read and understand the
            terms and conditions of the license they choose before applying it.
            Licensors should also secure all rights necessary before applying
            our licenses so that the public can reuse the material as expected.
            Licensors should clearly mark any material not subject to the
            license. This includes other CC-licensed material, or material used
            under an exception or limitation to copyright. More considerations
            for licensors :
            wiki.creativecommons.org/Considerations_for_licensors Considerations
            for the public: By using one of our public licenses, a licensor
            grants the public permission to use the licensed material under
            specified terms and conditions. If the licensor's permission is not
            necessary for any reason–for example, because of any applicable
            exception or limitation to copyright–then that use is not regulated
            by the license. Our licenses grant only permissions under copyright
            and certain other rights that a licensor has authority to grant. Use
            of the licensed material may still be restricted for other reasons,
            including because others have copyright or other rights in the
            material. A licensor may make special requests, such as asking that
            all changes be marked or described. Although not required by our
            licenses, you are encouraged to respect those requests where
            reasonable. More considerations for the public :
            wiki.creativecommons.org/Considerations_for_licensees Creative
            Commons Attribution 4.0 International Public License By exercising
            the Licensed Rights (defined below), You accept and agree to be
            bound by the terms and conditions of this Creative Commons
            Attribution 4.0 International Public License ("Public License"). To
            the extent this Public License may be interpreted as a contract, You
            are granted the Licensed Rights in consideration of Your acceptance
            of these terms and conditions, and the Licensor grants You such
            rights in consideration of benefits the Licensor receives from
            making the Licensed Material available under these terms and
            conditions. Section 1 – Definitions. a. Adapted Material means
            material subject to Copyright and Similar Rights that is derived
            from or based upon the Licensed Material and in which the Licensed
            Material is translated, altered, arranged, transformed, or otherwise
            modified in a manner requiring permission under the Copyright and
            Similar Rights held by the Licensor. For purposes of this Public
            License, where the Licensed Material is a musical work, performance,
            or sound recording, Adapted Material is always produced where the
            Licensed Material is synched in timed relation with a moving image.
            b. Adapter's License means the license You apply to Your Copyright
            and Similar Rights in Your contributions to Adapted Material in
            accordance with the terms and conditions of this Public License. c.
            Copyright and Similar Rights means copyright and/or similar rights
            closely related to copyright including, without limitation,
            performance, broadcast, sound recording, and Sui Generis Database
            Rights, without regard to how the rights are labeled or categorized.
            For purposes of this Public License, the rights specified in Section
            2(b)(1)-(2) are not Copyright and Similar Rights. d. Effective
            Technological Measures means those measures that, in the absence of
            proper authority, may not be circumvented under laws fulfilling
            obligations under Article 11 of the WIPO Copyright Treaty adopted on
            December 20, 1996, and/or similar international agreements. e.
            Exceptions and Limitations means fair use, fair dealing, and/or any
            other exception or limitation to Copyright and Similar Rights that
            applies to Your use of the Licensed Material. f. Licensed Material
            means the artistic or literary work, database, or other material to
            which the Licensor applied this Public License. g. Licensed Rights
            means the rights granted to You subject to the terms and conditions
            of this Public License, which are limited to all Copyright and
            Similar Rights that apply to Your use of the Licensed Material and
            that the Licensor has authority to license. h. Licensor means the
            individual(s) or entity(ies) granting rights under this Public
            License. i. Share means to provide material to the public by any
            means or process that requires permission under the Licensed Rights,
            such as reproduction, public display, public performance,
            distribution, dissemination, communication, or importation, and to
            make material available to the public including in ways that members
            of the public may access the material from a place and at a time
            individually chosen by them. j. Sui Generis Database Rights means
            rights other than copyright resulting from Directive 96/9/EC of the
            European Parliament and of the Council of 11 March 1996 on the legal
            protection of databases, as amended and/or succeeded, as well as
            other essentially equivalent rights anywhere in the world. k. You
            means the individual or entity exercising the Licensed Rights under
            this Public License. Your has a corresponding meaning. Section 2 –
            Scope. a. License grant. 1. Subject to the terms and conditions of
            this Public License, the Licensor hereby grants You a worldwide,
            royalty-free, non-sublicensable, non-exclusive, irrevocable license
            to exercise the Licensed Rights in the Licensed Material to: A.
            reproduce and Share the Licensed Material, in whole or in part; and
            B. produce, reproduce, and Share Adapted Material. 2. Exceptions and
            Limitations. For the avoidance of doubt, where Exceptions and
            Limitations apply to Your use, this Public License does not apply,
            and You do not need to comply with its terms and conditions. 3.
            Term. The term of this Public License is specified in Section 6(a).
            4. Media and formats; technical modifications allowed. The Licensor
            authorizes You to exercise the Licensed Rights in all media and
            formats whether now known or hereafter created, and to make
            technical modifications necessary to do so. The Licensor waives
            and/or agrees not to assert any right or authority to forbid You
            from making technical modifications necessary to exercise the
            Licensed Rights, including technical modifications necessary to
            circumvent Effective Technological Measures. For purposes of this
            Public License, simply making modifications authorized by this
            Section 2(a)(4) never produces Adapted Material. 5. Downstream
            recipients. A. Offer from the Licensor – Licensed Material. Every
            recipient of the Licensed Material automatically receives an offer
            from the Licensor to exercise the Licensed Rights under the terms
            and conditions of this Public License. B. No downstream
            restrictions. You may not offer or impose any additional or
            different terms or conditions on, or apply any Effective
            Technological Measures to, the Licensed Material if doing so
            restricts exercise of the Licensed Rights by any recipient of the
            Licensed Material. 6. No endorsement. Nothing in this Public License
            constitutes or may be construed as permission to assert or imply
            that You are, or that Your use of the Licensed Material is,
            connected with, or sponsored, endorsed, or granted official status
            by, the Licensor or others designated to receive attribution as
            provided in Section 3(a)(1)(A)(i). b. Other rights. 1. Moral rights,
            such as the right of integrity, are not licensed under this Public
            License, nor are publicity, privacy, and/or other similar
            personality rights; however, to the extent possible, the Licensor
            waives and/or agrees not to assert any such rights held by the
            Licensor to the limited extent necessary to allow You to exercise
            the Licensed Rights, but not otherwise. 2. Patent and trademark
            rights are not licensed under this Public License. 3. To the extent
            possible, the Licensor waives any right to collect royalties from
            You for the exercise of the Licensed Rights, whether directly or
            through a collecting society under any voluntary or waivable
            statutory or compulsory licensing scheme. In all other cases the
            Licensor expressly reserves any right to collect such royalties.
            Section 3 – License Conditions. Your exercise of the Licensed Rights
            is expressly made subject to the following conditions. a.
            Attribution. 1. If You Share the Licensed Material (including in
            modified form), You must: A. retain the following if it is supplied
            by the Licensor with the Licensed Material: i. identification of the
            creator(s) of the Licensed Material and any others designated to
            receive attribution, in any reasonable manner requested by the
            Licensor (including by pseudonym if designated); ii. a copyright
            notice; iii. a notice that refers to this Public License; iv. a
            notice that refers to the disclaimer of warranties; v. a URI or
            hyperlink to the Licensed Material to the extent reasonably
            practicable; B. indicate if You modified the Licensed Material and
            retain an indication of any previous modifications; and C. indicate
            the Licensed Material is licensed under this Public License, and
            include the text of, or the URI or hyperlink to, this Public
            License. 2. You may satisfy the conditions in Section 3(a)(1) in any
            reasonable manner based on the medium, means, and context in which
            You Share the Licensed Material. For example, it may be reasonable
            to satisfy the conditions by providing a URI or hyperlink to a
            resource that includes the required information. 3. If requested by
            the Licensor, You must remove any of the information required by
            Section 3(a)(1)(A) to the extent reasonably practicable. 4. If You
            Share Adapted Material You produce, the Adapter's License You apply
            must not prevent recipients of the Adapted Material from complying
            with this Public License. Section 4 – Sui Generis Database Rights.
            Where the Licensed Rights include Sui Generis Database Rights that
            apply to Your use of the Licensed Material: a. for the avoidance of
            doubt, Section 2(a)(1) grants You the right to extract, reuse,
            reproduce, and Share all or a substantial portion of the contents of
            the database; b. if You include all or a substantial portion of the
            database contents in a database in which You have Sui Generis
            Database Rights, then the database in which You have Sui Generis
            Database Rights (but not its individual contents) is Adapted
            Material; and c. You must comply with the conditions in Section 3(a)
            if You Share all or a substantial portion of the contents of the
            database. For the avoidance of doubt, this Section 4 supplements and
            does not replace Your obligations under this Public License where
            the Licensed Rights include other Copyright and Similar Rights.
            Section 5 – Disclaimer of Warranties and Limitation of Liability. a.
            Unless otherwise separately undertaken by the Licensor, to the
            extent possible, the Licensor offers the Licensed Material as-is and
            as-available, and makes no representations or warranties of any kind
            concerning the Licensed Material, whether express, implied,
            statutory, or other. This includes, without limitation, warranties
            of title, merchantability, fitness for a particular purpose,
            non-infringement, absence of latent or other defects, accuracy, or
            the presence or absence of errors, whether or not known or
            discoverable. Where disclaimers of warranties are not allowed in
            full or in part, this disclaimer may not apply to You. b. To the
            extent possible, in no event will the Licensor be liable to You on
            any legal theory (including, without limitation, negligence) or
            otherwise for any direct, special, indirect, incidental,
            consequential, punitive, exemplary, or other losses, costs,
            expenses, or damages arising out of this Public License or use of
            the Licensed Material, even if the Licensor has been advised of the
            possibility of such losses, costs, expenses, or damages. Where a
            limitation of liability is not allowed in full or in part, this
            limitation may not apply to You. c. The disclaimer of warranties and
            limitation of liability provided above shall be interpreted in a
            manner that, to the extent possible, most closely approximates an
            absolute disclaimer and waiver of all liability. Section 6 – Term
            and Termination. a. This Public License applies for the term of the
            Copyright and Similar Rights licensed here. However, if You fail to
            comply with this Public License, then Your rights under this Public
            License terminate automatically. b. Where Your right to use the
            Licensed Material has terminated under Section 6(a), it reinstates:
            1. automatically as of the date the violation is cured, provided it
            is cured within 30 days of Your discovery of the violation; or 2.
            upon express reinstatement by the Licensor. c. For the avoidance of
            doubt, this Section 6(b) does not affect any right the Licensor may
            have to seek remedies for Your violations of this Public License. d.
            For the avoidance of doubt, the Licensor may also offer the Licensed
            Material under separate terms or conditions or stop distributing the
            Licensed Material at any time; however, doing so will not terminate
            this Public License. e. Sections 1, 5, 6, 7, and 8 survive
            termination of this Public License. Section 7 – Other Terms and
            Conditions. a. The Licensor shall not be bound by any additional or
            different terms or conditions communicated by You unless expressly
            agreed. b. Any arrangements, understandings, or agreements regarding
            the Licensed Material not stated herein are separate from and
            independent of the terms and conditions of this Public License.
            Section 8 – Interpretation. a. For the avoidance of doubt, this
            Public License does not, and shall not be interpreted to, reduce,
            limit, restrict, or impose conditions on any use of the Licensed
            Material that could lawfully be made without permission under this
            Public License. b. To the extent possible, if any provision of this
            Public License is deemed unenforceable, it shall be automatically
            reformed to the minimum extent necessary to make it enforceable. If
            the provision cannot be reformed, it shall be severed from this
            Public License without affecting the enforceability of the remaining
            terms and conditions. c. No term or condition of this Public License
            will be waived and no failure to comply consented to unless
            expressly agreed to by the Licensor. d. Nothing in this Public
            License constitutes or may be interpreted as a limitation upon, or
            waiver of, any privileges and immunities that apply to the Licensor
            or You, including from the legal processes of any jurisdiction or
            authority. Creative Commons is not a party to its public licenses.
            Notwithstanding, Creative Commons may elect to apply one of its
            public licenses to material it publishes and in those instances will
            be considered the "Licensor." The text of the Creative Commons
            public licenses is dedicated to the public domain under the CC0
            Public Domain Dedication. Except for the limited purpose of
            indicating that material is shared under a Creative Commons public
            license or as otherwise permitted by the Creative Commons policies
            published at creativecommons.org/policies, Creative Commons does not
            authorize the use of the trademark "Creative Commons" or any other
            trademark or logo of Creative Commons without its prior written
            consent including, without limitation, in connection with any
            unauthorized modifications to any of its public licenses or any
            other arrangements, understandings, or agreements concerning use of
            licensed material. For the avoidance of doubt, this paragraph does
            not form part of the public licenses. Creative Commons may be
            contacted at creativecommons.org.
          </td>
          <td>https://creativecommons.org/licenses/by/4.0/</td>
        </tr>
        <tr>
          <td>@fortawesome/free-solid-svg-icons</td>
          <td>5.13.0</td>
          <td>Custom License</td>
          <td>
            Font Awesome Free License ------------------------- Font Awesome
            Free is free, open source, and GPL friendly. You can use it for
            commercial projects, open source projects, or really almost whatever
            you want. Full Font Awesome Free license:
            https://fontawesome.com/license/free. # Icons: CC BY 4.0 License
            (https://creativecommons.org/licenses/by/4.0/) In the Font Awesome
            Free download, the CC BY 4.0 license applies to all icons packaged
            as SVG and JS file types. # Fonts: SIL OFL 1.1 License
            (https://scripts.sil.org/OFL) In the Font Awesome Free download, the
            SIL OFL license applies to all icons packaged as web and desktop
            font files. # Code: MIT License
            (https://opensource.org/licenses/MIT) In the Font Awesome Free
            download, the MIT license applies to all non-font and non-icon
            files. # Attribution Attribution is required by MIT, SIL OFL, and CC
            BY licenses. Downloaded Font Awesome Free files already contain
            embedded comments with sufficient attribution, so you shouldn't need
            to do anything additional when using these files normally. We've
            kept attribution comments terse, so we ask that you do not actively
            work to remove them from files, especially code. They're a great way
            for folks to learn about Font Awesome. # Brand Icons All brand icons
            are trademarks of their respective owners. The use of these
            trademarks does not indicate endorsement of the trademark holder by
            Font Awesome, nor vice versa. **Please do not use brand logos for
            any purpose except to represent the company, product, or service to
            which they refer.**
          </td>
          <td>https://github.com/FortAwesome/Font-Awesome</td>
        </tr>
        <tr>
          <td>@fortawesome/free-solid-svg-icons</td>
          <td>5.13.0</td>
          <td>Creative Commons Attribution 4.0 International</td>
          <td>
            Creative Commons Attribution 4.0 International Creative Commons
            Corporation ("Creative Commons") is not a law firm and does not
            provide legal services or legal advice. Distribution of Creative
            Commons public licenses does not create a lawyer-client or other
            relationship. Creative Commons makes its licenses and related
            information available on an "as-is" basis. Creative Commons gives no
            warranties regarding its licenses, any material licensed under their
            terms and conditions, or any related information. Creative Commons
            disclaims all liability for damages resulting from their use to the
            fullest extent possible. Using Creative Commons Public Licenses
            Creative Commons public licenses provide a standard set of terms and
            conditions that creators and other rights holders may use to share
            original works of authorship and other material subject to copyright
            and certain other rights specified in the public license below. The
            following considerations are for informational purposes only, are
            not exhaustive, and do not form part of our licenses. Considerations
            for licensors: Our public licenses are intended for use by those
            authorized to give the public permission to use material in ways
            otherwise restricted by copyright and certain other rights. Our
            licenses are irrevocable. Licensors should read and understand the
            terms and conditions of the license they choose before applying it.
            Licensors should also secure all rights necessary before applying
            our licenses so that the public can reuse the material as expected.
            Licensors should clearly mark any material not subject to the
            license. This includes other CC-licensed material, or material used
            under an exception or limitation to copyright. More considerations
            for licensors :
            wiki.creativecommons.org/Considerations_for_licensors Considerations
            for the public: By using one of our public licenses, a licensor
            grants the public permission to use the licensed material under
            specified terms and conditions. If the licensor's permission is not
            necessary for any reason–for example, because of any applicable
            exception or limitation to copyright–then that use is not regulated
            by the license. Our licenses grant only permissions under copyright
            and certain other rights that a licensor has authority to grant. Use
            of the licensed material may still be restricted for other reasons,
            including because others have copyright or other rights in the
            material. A licensor may make special requests, such as asking that
            all changes be marked or described. Although not required by our
            licenses, you are encouraged to respect those requests where
            reasonable. More considerations for the public :
            wiki.creativecommons.org/Considerations_for_licensees Creative
            Commons Attribution 4.0 International Public License By exercising
            the Licensed Rights (defined below), You accept and agree to be
            bound by the terms and conditions of this Creative Commons
            Attribution 4.0 International Public License ("Public License"). To
            the extent this Public License may be interpreted as a contract, You
            are granted the Licensed Rights in consideration of Your acceptance
            of these terms and conditions, and the Licensor grants You such
            rights in consideration of benefits the Licensor receives from
            making the Licensed Material available under these terms and
            conditions. Section 1 – Definitions. a. Adapted Material means
            material subject to Copyright and Similar Rights that is derived
            from or based upon the Licensed Material and in which the Licensed
            Material is translated, altered, arranged, transformed, or otherwise
            modified in a manner requiring permission under the Copyright and
            Similar Rights held by the Licensor. For purposes of this Public
            License, where the Licensed Material is a musical work, performance,
            or sound recording, Adapted Material is always produced where the
            Licensed Material is synched in timed relation with a moving image.
            b. Adapter's License means the license You apply to Your Copyright
            and Similar Rights in Your contributions to Adapted Material in
            accordance with the terms and conditions of this Public License. c.
            Copyright and Similar Rights means copyright and/or similar rights
            closely related to copyright including, without limitation,
            performance, broadcast, sound recording, and Sui Generis Database
            Rights, without regard to how the rights are labeled or categorized.
            For purposes of this Public License, the rights specified in Section
            2(b)(1)-(2) are not Copyright and Similar Rights. d. Effective
            Technological Measures means those measures that, in the absence of
            proper authority, may not be circumvented under laws fulfilling
            obligations under Article 11 of the WIPO Copyright Treaty adopted on
            December 20, 1996, and/or similar international agreements. e.
            Exceptions and Limitations means fair use, fair dealing, and/or any
            other exception or limitation to Copyright and Similar Rights that
            applies to Your use of the Licensed Material. f. Licensed Material
            means the artistic or literary work, database, or other material to
            which the Licensor applied this Public License. g. Licensed Rights
            means the rights granted to You subject to the terms and conditions
            of this Public License, which are limited to all Copyright and
            Similar Rights that apply to Your use of the Licensed Material and
            that the Licensor has authority to license. h. Licensor means the
            individual(s) or entity(ies) granting rights under this Public
            License. i. Share means to provide material to the public by any
            means or process that requires permission under the Licensed Rights,
            such as reproduction, public display, public performance,
            distribution, dissemination, communication, or importation, and to
            make material available to the public including in ways that members
            of the public may access the material from a place and at a time
            individually chosen by them. j. Sui Generis Database Rights means
            rights other than copyright resulting from Directive 96/9/EC of the
            European Parliament and of the Council of 11 March 1996 on the legal
            protection of databases, as amended and/or succeeded, as well as
            other essentially equivalent rights anywhere in the world. k. You
            means the individual or entity exercising the Licensed Rights under
            this Public License. Your has a corresponding meaning. Section 2 –
            Scope. a. License grant. 1. Subject to the terms and conditions of
            this Public License, the Licensor hereby grants You a worldwide,
            royalty-free, non-sublicensable, non-exclusive, irrevocable license
            to exercise the Licensed Rights in the Licensed Material to: A.
            reproduce and Share the Licensed Material, in whole or in part; and
            B. produce, reproduce, and Share Adapted Material. 2. Exceptions and
            Limitations. For the avoidance of doubt, where Exceptions and
            Limitations apply to Your use, this Public License does not apply,
            and You do not need to comply with its terms and conditions. 3.
            Term. The term of this Public License is specified in Section 6(a).
            4. Media and formats; technical modifications allowed. The Licensor
            authorizes You to exercise the Licensed Rights in all media and
            formats whether now known or hereafter created, and to make
            technical modifications necessary to do so. The Licensor waives
            and/or agrees not to assert any right or authority to forbid You
            from making technical modifications necessary to exercise the
            Licensed Rights, including technical modifications necessary to
            circumvent Effective Technological Measures. For purposes of this
            Public License, simply making modifications authorized by this
            Section 2(a)(4) never produces Adapted Material. 5. Downstream
            recipients. A. Offer from the Licensor – Licensed Material. Every
            recipient of the Licensed Material automatically receives an offer
            from the Licensor to exercise the Licensed Rights under the terms
            and conditions of this Public License. B. No downstream
            restrictions. You may not offer or impose any additional or
            different terms or conditions on, or apply any Effective
            Technological Measures to, the Licensed Material if doing so
            restricts exercise of the Licensed Rights by any recipient of the
            Licensed Material. 6. No endorsement. Nothing in this Public License
            constitutes or may be construed as permission to assert or imply
            that You are, or that Your use of the Licensed Material is,
            connected with, or sponsored, endorsed, or granted official status
            by, the Licensor or others designated to receive attribution as
            provided in Section 3(a)(1)(A)(i). b. Other rights. 1. Moral rights,
            such as the right of integrity, are not licensed under this Public
            License, nor are publicity, privacy, and/or other similar
            personality rights; however, to the extent possible, the Licensor
            waives and/or agrees not to assert any such rights held by the
            Licensor to the limited extent necessary to allow You to exercise
            the Licensed Rights, but not otherwise. 2. Patent and trademark
            rights are not licensed under this Public License. 3. To the extent
            possible, the Licensor waives any right to collect royalties from
            You for the exercise of the Licensed Rights, whether directly or
            through a collecting society under any voluntary or waivable
            statutory or compulsory licensing scheme. In all other cases the
            Licensor expressly reserves any right to collect such royalties.
            Section 3 – License Conditions. Your exercise of the Licensed Rights
            is expressly made subject to the following conditions. a.
            Attribution. 1. If You Share the Licensed Material (including in
            modified form), You must: A. retain the following if it is supplied
            by the Licensor with the Licensed Material: i. identification of the
            creator(s) of the Licensed Material and any others designated to
            receive attribution, in any reasonable manner requested by the
            Licensor (including by pseudonym if designated); ii. a copyright
            notice; iii. a notice that refers to this Public License; iv. a
            notice that refers to the disclaimer of warranties; v. a URI or
            hyperlink to the Licensed Material to the extent reasonably
            practicable; B. indicate if You modified the Licensed Material and
            retain an indication of any previous modifications; and C. indicate
            the Licensed Material is licensed under this Public License, and
            include the text of, or the URI or hyperlink to, this Public
            License. 2. You may satisfy the conditions in Section 3(a)(1) in any
            reasonable manner based on the medium, means, and context in which
            You Share the Licensed Material. For example, it may be reasonable
            to satisfy the conditions by providing a URI or hyperlink to a
            resource that includes the required information. 3. If requested by
            the Licensor, You must remove any of the information required by
            Section 3(a)(1)(A) to the extent reasonably practicable. 4. If You
            Share Adapted Material You produce, the Adapter's License You apply
            must not prevent recipients of the Adapted Material from complying
            with this Public License. Section 4 – Sui Generis Database Rights.
            Where the Licensed Rights include Sui Generis Database Rights that
            apply to Your use of the Licensed Material: a. for the avoidance of
            doubt, Section 2(a)(1) grants You the right to extract, reuse,
            reproduce, and Share all or a substantial portion of the contents of
            the database; b. if You include all or a substantial portion of the
            database contents in a database in which You have Sui Generis
            Database Rights, then the database in which You have Sui Generis
            Database Rights (but not its individual contents) is Adapted
            Material; and c. You must comply with the conditions in Section 3(a)
            if You Share all or a substantial portion of the contents of the
            database. For the avoidance of doubt, this Section 4 supplements and
            does not replace Your obligations under this Public License where
            the Licensed Rights include other Copyright and Similar Rights.
            Section 5 – Disclaimer of Warranties and Limitation of Liability. a.
            Unless otherwise separately undertaken by the Licensor, to the
            extent possible, the Licensor offers the Licensed Material as-is and
            as-available, and makes no representations or warranties of any kind
            concerning the Licensed Material, whether express, implied,
            statutory, or other. This includes, without limitation, warranties
            of title, merchantability, fitness for a particular purpose,
            non-infringement, absence of latent or other defects, accuracy, or
            the presence or absence of errors, whether or not known or
            discoverable. Where disclaimers of warranties are not allowed in
            full or in part, this disclaimer may not apply to You. b. To the
            extent possible, in no event will the Licensor be liable to You on
            any legal theory (including, without limitation, negligence) or
            otherwise for any direct, special, indirect, incidental,
            consequential, punitive, exemplary, or other losses, costs,
            expenses, or damages arising out of this Public License or use of
            the Licensed Material, even if the Licensor has been advised of the
            possibility of such losses, costs, expenses, or damages. Where a
            limitation of liability is not allowed in full or in part, this
            limitation may not apply to You. c. The disclaimer of warranties and
            limitation of liability provided above shall be interpreted in a
            manner that, to the extent possible, most closely approximates an
            absolute disclaimer and waiver of all liability. Section 6 – Term
            and Termination. a. This Public License applies for the term of the
            Copyright and Similar Rights licensed here. However, if You fail to
            comply with this Public License, then Your rights under this Public
            License terminate automatically. b. Where Your right to use the
            Licensed Material has terminated under Section 6(a), it reinstates:
            1. automatically as of the date the violation is cured, provided it
            is cured within 30 days of Your discovery of the violation; or 2.
            upon express reinstatement by the Licensor. c. For the avoidance of
            doubt, this Section 6(b) does not affect any right the Licensor may
            have to seek remedies for Your violations of this Public License. d.
            For the avoidance of doubt, the Licensor may also offer the Licensed
            Material under separate terms or conditions or stop distributing the
            Licensed Material at any time; however, doing so will not terminate
            this Public License. e. Sections 1, 5, 6, 7, and 8 survive
            termination of this Public License. Section 7 – Other Terms and
            Conditions. a. The Licensor shall not be bound by any additional or
            different terms or conditions communicated by You unless expressly
            agreed. b. Any arrangements, understandings, or agreements regarding
            the Licensed Material not stated herein are separate from and
            independent of the terms and conditions of this Public License.
            Section 8 – Interpretation. a. For the avoidance of doubt, this
            Public License does not, and shall not be interpreted to, reduce,
            limit, restrict, or impose conditions on any use of the Licensed
            Material that could lawfully be made without permission under this
            Public License. b. To the extent possible, if any provision of this
            Public License is deemed unenforceable, it shall be automatically
            reformed to the minimum extent necessary to make it enforceable. If
            the provision cannot be reformed, it shall be severed from this
            Public License without affecting the enforceability of the remaining
            terms and conditions. c. No term or condition of this Public License
            will be waived and no failure to comply consented to unless
            expressly agreed to by the Licensor. d. Nothing in this Public
            License constitutes or may be interpreted as a limitation upon, or
            waiver of, any privileges and immunities that apply to the Licensor
            or You, including from the legal processes of any jurisdiction or
            authority. Creative Commons is not a party to its public licenses.
            Notwithstanding, Creative Commons may elect to apply one of its
            public licenses to material it publishes and in those instances will
            be considered the "Licensor." The text of the Creative Commons
            public licenses is dedicated to the public domain under the CC0
            Public Domain Dedication. Except for the limited purpose of
            indicating that material is shared under a Creative Commons public
            license or as otherwise permitted by the Creative Commons policies
            published at creativecommons.org/policies, Creative Commons does not
            authorize the use of the trademark "Creative Commons" or any other
            trademark or logo of Creative Commons without its prior written
            consent including, without limitation, in connection with any
            unauthorized modifications to any of its public licenses or any
            other arrangements, understandings, or agreements concerning use of
            licensed material. For the avoidance of doubt, this paragraph does
            not form part of the public licenses. Creative Commons may be
            contacted at creativecommons.org.
          </td>
          <td>https://creativecommons.org/licenses/by/4.0/</td>
        </tr>
        <tr>
          <td>@fortawesome/react-fontawesome</td>
          <td>0.1.9</td>
          <td>MIT License</td>
          <td>
            Copyright 2018 Fonticons, Inc. Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/FortAwesome/react-fontawesome/tree/0.1.9</td>
        </tr>
        <tr>
          <td>@material-ui/react-transition-group</td>
          <td>4.3.0</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            BSD 3-Clause License Copyright (c) 2018, React Community Forked from
            React (https://github.com/facebook/react) Copyright 2013-present,
            Facebook, Inc. All rights reserved. Redistribution and use in source
            and binary forms, with or without modification, are permitted
            provided that the following conditions are met: * Redistributions of
            source code must retain the above copyright notice, this list of
            conditions and the following disclaimer. * Redistributions in binary
            form must reproduce the above copyright notice, this list of
            conditions and the following disclaimer in the documentation and/or
            other materials provided with the distribution. * Neither the name
            of the copyright holder nor the names of its contributors may be
            used to endorse or promote products derived from this software
            without specific prior written permission. THIS SOFTWARE IS PROVIDED
            BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
            CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
            USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
            OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGE.
          </td>
          <td>https://github.com/mui-org/react-transition-group</td>
        </tr>
        <tr>
          <td>@material-ui/system</td>
          <td>4.9.13</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Call-Em-All Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/mui-org/material-ui/tree/v4.9.13</td>
        </tr>
        <tr>
          <td>@material-ui/types</td>
          <td>5.0.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Call-Em-All Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/mui-org/material-ui</td>
        </tr>
        <tr>
          <td>@material-ui/utils</td>
          <td>4.9.12</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Call-Em-All Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/mui-org/material-ui/tree/v4.9.12</td>
        </tr>
        <tr>
          <td>@trendmicro/react-sidenav</td>
          <td>0.4.5</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2017 Trend Micro Inc. Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/trendmicro-frontend/react-sidenav/tree/v0.4.5
          </td>
        </tr>
        <tr>
          <td>@types/parse-json</td>
          <td>4.0.0</td>
          <td>MIT License</td>
          <td>
            This project is licensed under the MIT license. Copyrights are
            respective of each contributor listed at the beginning of each
            definition file. Permission is hereby granted, free of charge, to
            any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/DefinitelyTyped/DefinitelyTyped</td>
        </tr>
        <tr>
          <td>@types/prop-types</td>
          <td>15.7.3</td>
          <td>MIT License</td>
          <td>
            This project is licensed under the MIT license. Copyrights are
            respective of each contributor listed at the beginning of each
            definition file. Permission is hereby granted, free of charge, to
            any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE. ---- Excerpt from
            https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/.github/CODEOWNERS
            /types/prop-types/ @DovydasNavickas @ferdaber @eps1lon
          </td>
          <td>https://github.com/DefinitelyTyped/DefinitelyTyped</td>
        </tr>
        <tr>
          <td>@types/react</td>
          <td>16.9.34</td>
          <td>MIT License</td>
          <td>
            This project is licensed under the MIT license. Copyrights are
            respective of each contributor listed at the beginning of each
            definition file. Permission is hereby granted, free of charge, to
            any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE. ---- Excerpt from
            https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/.github/CODEOWNERS
            /types/react/ @johnnyreilly @bbenezech @pzavolinsky @digiguru
            @ericanderson @DovydasNavickas @theruther4d @guilhermehubner
            @ferdaber @jrakotoharisoa @pascaloliv @hotell @franklixuefei
            @Jessidhia @saranshkataria @lukyth @eps1lon @zieka @dancerphil
            @dimitropoulos @disjukr @vhfmag
          </td>
          <td>https://github.com/DefinitelyTyped/DefinitelyTyped</td>
        </tr>
        <tr>
          <td>@types/react-transition-group</td>
          <td>4.2.4</td>
          <td>MIT License</td>
          <td>
            This project is licensed under the MIT license. Copyrights are
            respective of each contributor listed at the beginning of each
            definition file. Permission is hereby granted, free of charge, to
            any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE. ---- Excerpt from
            https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/.github/CODEOWNERS
            /types/react-transition-group/ @LKay @Epskampie @ybiquitous @tu4mo
            @bengry
          </td>
          <td>https://github.com/DefinitelyTyped/DefinitelyTyped</td>{' '}
        </tr>
        <tr>
          <td>ansi-styles</td>
          <td>3.2.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/chalk/ansi-styles/tree/v3.2.1</td>
        </tr>
        <tr>
          <td>axios</td>
          <td>0.19.2</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2014-present Matt Zabriskie Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/axios/axios/tree/v0.19.2</td>
        </tr>
        <tr>
          <td>babel-plugin-emotion</td>
          <td>10.0.33</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Emotion team and other contributors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/emotion-js/emotion/tree/babel-plugin-emotion%4010.0.33/packages/babel-plugin-emotion
          </td>
        </tr>
        <tr>
          <td>babel-plugin-macros</td>
          <td>2.8.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2017 Kent C. Dodds Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/kentcdodds/babel-plugin-macros/tree/v2.8.0</td>
        </tr>
        <tr>
          <td>babel-plugin-syntax-jsx</td>
          <td>6.18.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
        </tr>
        <tr>
          <td>babel-runtime</td>
          <td>6.26.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present Sebastian McKenzie and other
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>
            https://github.com/babel/babel/tree/master/packages/babel-runtime
          </td>
        </tr>
        <tr>
          <td>bootstrap</td>
          <td>4.4.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2011-2019 Twitter, Inc.
            Copyright (c) 2011-2019 The Bootstrap Authors Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/twbs/bootstrap/tree/v4.4.1</td>
        </tr>
        <tr>
          <td>callsites</td>
          <td>3.1.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/callsites/tree/v3.1.0</td>
        </tr>
        <tr>
          <td>camelcase</td>
          <td>5.3.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/camelcase/tree/v5.3.1</td>
        </tr>
        <tr>
          <td>chained-function</td>
          <td>0.5.0</td>
          <td>MIt License</td>
          <td>
            MIT License Copyright (c) 2017 Cheton Wu Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/cheton/chained-function/tree/v0.5.0</td>
        </tr>
        <tr>
          <td>chain-function</td>
          <td>1.0.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jason Quense Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/jquense/chain-function</td>
        </tr>
        <tr>
          <td>chalk</td>
          <td>2.4.2</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/chalk/chalk/tree/v2.4.2</td>
        </tr>
        <tr>
          <td>classnames</td>
          <td>2.2.6</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2017 Jed Watson Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/JedWatson/classnames/tree/v2.2.6</td>
        </tr>
        <tr>
          <td>clone</td>
          <td>2.1.2</td>
          <td>MIT License</td>
          <td>
            Copyright © 2011-2015 Paul Vorbach {'<'}paul@vorba.ch{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the “Software”), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED “AS
            IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
            OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/pvorb/clone/tree/v2.1.2</td>
        </tr>
        <tr>
          <td>clsx</td>
          <td>1.1.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Luke Edwards {'<'}luke.edwards05@gmail.com
            {'>'} (lukeed.com) Permission is hereby granted, free of charge, to
            any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/lukeed/clsx/tree/v1.1.0</td>
        </tr>
        <tr>
          <td>color-convert</td>
          <td>1.9.3</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2011-2016 Heather Arthur {'<'}fayearthur@gmail.com
            {'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
        </tr>
        <tr>
          <td>color-name</td>
          <td>1.1.3</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Dmitry Ivanov Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/colorjs/color-name/tree/v1.1.3</td>
        </tr>
        <tr>
          <td>convert-source-map</td>
          <td>1.7.0</td>
          <td>MIT License</td>
          <td>
            Copyright 2013 Thorsten Lorenz. All rights reserved. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/thlorenz/convert-source-map/tree/v1.7.0</td>
        </tr>
        <tr>
          <td>core-js</td>
          <td>2.6.11</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2014-2019 Denis Pushkarev Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/zloirock/core-js/tree/v2.6.11</td>
        </tr>
        <tr>
          <td>cosmiconfig</td>
          <td>6.0.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 David Clark Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/davidtheclark/cosmiconfig/tree/6.0.0</td>
        </tr>
        <tr>
          <td>create-react-context</td>
          <td>0.3.0</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2017-present James Kyle {'<'}me@thejameskyle.com{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/jamiebuilds/create-react-context/tree/v0.3.0
          </td>
        </tr>
        <tr>
          <td>csstype</td>
          <td>2.6.10</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2017-2018 Fredrik Nicol Permission is hereby granted,
            free of charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/frenic/csstype/tree/v2.6.10</td>
        </tr>
        <tr>
          <td>css-vendor</td>
          <td>2.0.8</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Slobodskoi
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/css-vendor/tree/v2.0.8</td>
        </tr>
        <tr>
          <td>d3</td>
          <td>3.5.17</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright (c) 2010-2016, Michael Bostock All rights reserved.
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: * Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. * Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. * The name Michael Bostock may not be used to
            endorse or promote products derived from this software without
            specific prior written permission. THIS SOFTWARE IS PROVIDED BY THE
            COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL MICHAEL BOSTOCK BE LIABLE FOR ANY
            DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
            DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
            GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
            INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER
            IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
            OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
            IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/d3/d3/tree/v3.5.17</td>
        </tr>
        <tr>
          <td>debug</td>
          <td>3.1.0</td>
          <td>MIT License</td>
          <td>
            (The MIT License) Copyright (c) 2014 TJ Holowaychuk {'<'}
            tj@vision-media.ca{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the 'Software'), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED 'AS
            IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/visionmedia/debug/tree/3.1.0</td>
        </tr>
        <tr>
          <td>deep-equal</td>
          <td>1.1.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2012, 2013, 2014 James Halliday {'<'}
            mail@substack.net{'>'}, 2009 Thomas Robinson {'<'}280north.com{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/node-deep-equal/tree/v1.1.1</td>
        </tr>
        <tr>
          <td>deepmerge</td>
          <td>4.2.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2012 James Halliday, Josh Duff,
            and other contributors Permission is hereby granted, free of charge,
            to any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/TehShrike/deepmerge/tree/v4.2.2</td>
        </tr>
        <tr>
          <td>define-properties</td>
          <td>1.1.3</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (C) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ljharb/define-properties/tree/v1.1.3</td>
        </tr>
        <tr>
          <td>dom-helpers</td>
          <td>3.4.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jason Quense Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/react-bootstrap/dom-helpers/tree/v3.4.0</td>
        </tr>
        <tr>
          <td>dom-helpers</td>
          <td>5.1.4</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jason Quense Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/react-bootstrap/dom-helpers/tree/v5.1.4</td>
        </tr>
        <tr>
          <td>error-ex</td>
          <td>1.3.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 JD Ballard Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/Qix-/node-error-ex/tree/1.3.2</td>
        </tr>
        <tr>
          <td>es-abstract</td>
          <td>1.17.5</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (C) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ljharb/es-abstract/tree/v1.17.5</td>
        </tr>
        <tr>
          <td>escape-string-regexp</td>
          <td>1.0.5</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) Sindre Sorhus {'<'}
            sindresorhus@gmail.com{'>'} (sindresorhus.com) Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/sindresorhus/escape-string-regexp/tree/v1.0.5
          </td>
        </tr>
        <tr>
          <td>es-to-primitive</td>
          <td>1.2.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ljharb/es-to-primitive/tree/v1.2.1</td>
        </tr>
        <tr>
          <td>find-root</td>
          <td>1.1.0</td>
          <td>MIT License</td>
          <td>
            Copyright © 2017 jsdnxx Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the “Software”), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/junosuarez/find-root/tree/v1.1.0</td>
        </tr>
        <tr>
          <td>follow-redirects</td>
          <td>1.5.10</td>
          <td>MIT License</td>
          <td>
            Copyright 2014–present Olivier Lalonde {'<'}olalonde@gmail.com{'>'},
            James Talmage {'<'}james@talmage.io{'>'}, Ruben Verborgh Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/follow-redirects/follow-redirects/tree/v1.5.10
          </td>
        </tr>
        <tr>
          <td>function-bind</td>
          <td>1.1.1</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2013 Raynos. Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/Raynos/function-bind/tree/v1.1.1</td>
        </tr>
        <tr>
          <td>gud</td>
          <td>1.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/jamiebuilds/global-unique-id</td>
        </tr>
        <tr>
          <td>has</td>
          <td>1.0.3</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2013 Thiago de Arruda Permission is hereby granted,
            free of charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/tarruda/has/tree/v1.0.3</td>
        </tr>
        <tr>
          <td>has-flag</td>
          <td>3.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/has-flag/tree/v3.0.0</td>
        </tr>
        <tr>
          <td>has-symbols</td>
          <td>1.0.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2016 Jordan Harband Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/has-symbols/tree/v1.0.1</td>
        </tr>
        <tr>
          <td>history</td>
          <td>4.10.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) React Training 2016-2018 Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ReactTraining/history/tree/v4.10.1</td>
        </tr>
        <tr>
          <td>hoist-non-react-statics</td>
          <td>3.3.2</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Software License Agreement (BSD License)
            ======================================== Copyright (c) 2015, Yahoo!
            Inc. All rights reserved.
            ---------------------------------------------------- Redistribution
            and use of this software in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: * Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. * Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. * Neither the name of Yahoo! Inc. nor the names of
            YUI's contributors may be used to endorse or promote products
            derived from this software without specific prior written permission
            of Yahoo! Inc. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS
            AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>
            https://github.com/mridgway/hoist-non-react-statics/tree/v3.3.2
          </td>
        </tr>
        <tr>
          <td>hyphenate-style-name</td>
          <td>1.0.3</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright (c) 2015, Espen Hovlandsdal All rights reserved.
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: * Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. * Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. * Neither the name of hyphenate-style-name nor the
            names of its contributors may be used to endorse or promote products
            derived from this software without specific prior written
            permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
            CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/rexxars/hyphenate-style-name/tree/v1.0.3</td>
        </tr>
        <tr>
          <td>import-fresh</td>
          <td>3.2.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/import-fresh/tree/v3.2.1</td>
        </tr>
        <tr>
          <td>invariant</td>
          <td>2.2.4</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2013-present, Facebook, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/zertosh/invariant/tree/v2.2.4</td>
        </tr>
        <tr>
          <td>is-arguments</td>
          <td>1.0.4</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/is-arguments/tree/v1.0.4</td>
        </tr>
        <tr>
          <td>isarray</td>
          <td>0.0.1</td>
          <td>MIT License</td>
          <td>
            (MIT) Copyright (c) 2013 Julian Gruber {'<'}julian@juliangruber.com
            {'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/juliangruber/isarray/tree/0.0.1</td>
        </tr>
        <tr>
          <td>is-arrayish</td>
          <td>0.2.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 JD Ballard Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/Qix-/node-is-arrayish/tree/0.2.1</td>
        </tr>
        <tr>
          <td>is-callable</td>
          <td>1.1.5</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/is-callable/tree/v1.1.5</td>
        </tr>
        <tr>
          <td>is-data-object</td>
          <td>1.0.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/is-date-object/tree/v1.0.2</td>
        </tr>
        <tr>
          <td>is-in-browser</td>
          <td>1.1.3</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2016-2019 Jared Anderson Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/tuxsudo/is-in-browser</td>
        </tr>
        <tr>
          <td>is-regex</td>
          <td>1.0.5</td>
          <td>MIT license</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/is-regex/tree/v1.0.5</td>
        </tr>
        <tr>
          <td>is-symbol</td>
          <td>1.0.3</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/is-symbol/tree/v1.0.3</td>
        </tr>
        <tr>
          <td>json-parse-better-errors</td>
          <td>1.0.2</td>
          <td>MIT License</td>
          <td>
            Copyright 2017 Kat Marchán Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/zkat/json-parse-better-errors/tree/v1.0.2</td>
        </tr>
        <tr>
          <td>jsPDF</td>
          <td>1.5.3</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2010-2016 James Hall, https://github.com/MrRio/jsPDF
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/MrRio/jsPDF/tree/v1.5.3</td>
        </tr>
        <tr>
          <td>jsPDF-AutoTable</td>
          <td>3.5.6</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Simon Bengtsson,
            https://github.com/simonbengtsson/jspdf-autotable Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/simonbengtsson/jsPDF-AutoTable/tree/v3.5.6</td>
        </tr>
        <tr>
          <td>jss</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-camel-case</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-default-unit</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-global</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-nested</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-props-sort</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-rule-value-function</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-rule-value-function</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>jss-plugin-vendor-prefixer</td>
          <td>10.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014-present Oleg Isonen
            (Slobodskoi) & contributors Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/cssinjs/jss/tree/v10.1.1</td>
        </tr>
        <tr>
          <td>js-tokens</td>
          <td>4.0.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014, 2015, 2016, 2017, 2018
            Simon Lydell Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/lydell/js-tokens/tree/v4.0.0</td>
        </tr>
        <tr>
          <td>lines-and-columns</td>
          <td>1.1.6</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Brian Donovan Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/eventualbuddha/lines-and-columns/tree/v1.1.6
          </td>
        </tr>
        <tr>
          <td>lodash</td>
          <td>4.17.15</td>
          <td>Custom License and MIT License</td>
          <td>
            Copyright OpenJS Foundation and other contributors {'<'}
            https://openjsf.org/{'>'}
            Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and
            Investigative Reporters & Editors {'<'}http://underscorejs.org/{'>'}
            This software consists of voluntary contributions made by many
            individuals. For exact contribution history, see the revision
            history available at https://github.com/lodash/lodash The following
            license applies to all parts of this software except as documented
            below: ==== Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE. ==== Copyright and related rights for sample code are
            waived via CC0. Sample code is defined as all source code displayed
            within the prose of the documentation. CC0:
            http://creativecommons.org/publicdomain/zero/1.0/ ==== Files located
            in the node_modules and vendor directories are externally maintained
            libraries used by this software which have their own licenses; we
            recommend you read them, as their terms may differ from the terms
            above.
          </td>
          <td>https://github.com/lodash/lodash/tree/4.17.15</td>
        </tr>
        <tr>
          <td>lodash.isplainobject</td>
          <td>4.0.6</td>
          <td>Custom License and MIT License</td>
          <td>
            Copyright jQuery Foundation and other contributors {'<'}
            https://jquery.org/{'>'}
            Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and
            Investigative Reporters & Editors {'<'}http://underscorejs.org/{'>'}
            This software consists of voluntary contributions made by many
            individuals. For exact contribution history, see the revision
            history available at https://github.com/lodash/lodash The following
            license applies to all parts of this software except as documented
            below: ==== Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE. ==== Copyright and related rights for sample code are
            waived via CC0. Sample code is defined as all source code displayed
            within the prose of the documentation. CC0:
            http://creativecommons.org/publicdomain/zero/1.0/ ==== Files located
            in the node_modules and vendor directories are externally maintained
            libraries used by this software which have their own licenses; we
            recommend you read them, as their terms may differ from the terms
            above.
          </td>
          <td>
            https://github.com/lodash/lodash/tree/4.0.6-npm-packages/lodash.isplainobject
          </td>
        </tr>
        <tr>
          <td>lodash.orderby</td>
          <td>4.6.0</td>
          <td>Custom License and MIT License</td>
          <td>
            Copyright jQuery Foundation and other contributors {'<'}
            https://jquery.org/{'>'}
            Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and
            Investigative Reporters & Editors{'<'}http://underscorejs.org/{'>'}
            This software consists of voluntary contributions made by many
            individuals. For exact contribution history, see the revision
            history available at https://github.com/lodash/lodash The following
            license applies to all parts of this software except as documented
            below: ==== Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE. ==== Copyright and related rights for sample code are
            waived via CC0. Sample code is defined as all source code displayed
            within the prose of the documentation. CC0:
            http://creativecommons.org/publicdomain/zero/1.0/ ==== Files located
            in the node_modules and vendor directories are externally maintained
            libraries used by this software which have their own licenses; we
            recommend you read them, as their terms may differ from the terms
            above.
          </td>
          <td>
            https://github.com/lodash/lodash/tree/4.6.0-npm-packages/lodash.orderby
          </td>
        </tr>
        <tr>
          <td>loose-envify</td>
          <td>1.4.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Andres Suarez {'<'}
            zertosh@gmail.com{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/zertosh/loose-envify/tree/v1.4.0</td>
        </tr>
        <tr>
          <td>memoize-one</td>
          <td>5.1.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2019 Alexander Reardon Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/alexreardon/memoize-one/tree/v5.1.1</td>
        </tr>
        <tr>
          <td>mini-create-react-context</td>
          <td>0.3.2</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2019-present StringEpsilon {'<'}
            StringEpsilon@gmail.com{'>'}
            Copyright (c) 2017-2019 James Kyle {'<'}me@thejameskyle.com{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/StringEpsilon/mini-create-react-context/tree/0.3.2
          </td>
        </tr>
        <tr>
          <td>m</td>
          <td>2.0.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2016 Zeit, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/vercel/ms/tree/2.0.0</td>
        </tr>
        <tr>
          <td>nanoid</td>
          <td>2.1.11</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright 2017 Andrey Sitnik {'<'}
            andrey@sitnik.ru{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ai/nanoid/tree/2.1.11</td>
        </tr>
        <tr>
          <td>object.assign</td>
          <td>4.1.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ljharb/object.assign/tree/v4.1.0</td>
        </tr>
        <tr>
          <td>object-assign</td>
          <td>4.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) Sindre Sorhus {'<'}
            sindresorhus@gmail.com{'>'} (sindresorhus.com) Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/object-assign/tree/v4.1.1</td>
        </tr>
        <tr>
          <td>object-inspect</td>
          <td>1.7.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2013 James Halliday Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/inspect-js/object-inspect/tree/v1.7.0</td>
        </tr>
        <tr>
          <td>object-is</td>
          <td>1.1.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/es-shims/object-is/tree/v1.1.2</td>
        </tr>
        <tr>
          <td>object-keys</td>
          <td>1.1.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (C) 2013 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ljharb/object-keys/tree/v1.1.1</td>
        </tr>
        <tr>
          <td>parent-module</td>
          <td>1.0.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/parent-module/tree/v1.0.1</td>
        </tr>
        <tr>
          <td>parse-json</td>
          <td>5.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/parse-json/tree/v5.0.0</td>
        </tr>
        <tr>
          <td>path-parse</td>
          <td>1.0.6</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Javier Blanco Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/jbgutierrez/path-parse</td>
        </tr>
        <tr>
          <td>path-to-regexp</td>
          <td>1.8.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2014 Blake Embrey
            (hello@blakeembrey.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/pillarjs/path-to-regexp/tree/v1.8.0</td>
        </tr>
        <tr>
          <td>path-type</td>
          <td>4.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/path-type/tree/v4.0.0</td>
        </tr>
        <tr>
          <td>popper.js</td>
          <td>1.16.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright © 2016 Federico Zivolo and
            contributors Permission is hereby granted, free of charge, to any
            person obtaining a copy of this software and associated
            documentation files (the “Software”), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED “AS IS”, WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/popperjs/popper-core/tree/v1.16.1</td>
        </tr>
        <tr>
          <td>prop-types</td>
          <td>15.7.2</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2013-present, Facebook, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/facebook/prop-types/tree/v15.7.2</td>
        </tr>
        <tr>
          <td>react</td>
          <td>16.13.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Facebook, Inc. and its affiliates.
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/facebook/react/tree/v16.13.1</td>
        </tr>
        <tr>
          <td>react-contexify</td>
          <td>4.1.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2018 Fadi Khadra Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/fkhadra/react-contexify/tree/v4.1.1</td>
        </tr>
        <tr>
          <td>react-d3-tree</td>
          <td>1.16.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2017 Ben Kremer Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/bkrem/react-d3-tree/tree/v1.16.1</td>
        </tr>
        <tr>
          <td>react-data-table-component</td>
          <td>6.9.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2017 jbetancur Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/jbetancur/react-data-table-component/tree/v6.9.1
          </td>
        </tr>
        <tr>
          <td>react-dom</td>
          <td>16.13.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Facebook, Inc. and its affiliates.
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/facebook/react/tree/v16.13.1</td>
        </tr>
        <tr>
          <td>react-input-autosize</td>
          <td>2.2.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2018 Jed Watson Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/JedWatson/react-input-autosize</td>
        </tr>
        <tr>
          <td>react-is</td>
          <td>16.13.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Facebook, Inc. and its affiliates.
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/facebook/react/tree/v16.13.1</td>
        </tr>
        <tr>
          <td>react-lifecycles-compat</td>
          <td>3.0.4</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2013-present, Facebook, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/reactjs/react-lifecycles-compat</td>
        </tr>
        <tr>
          <td>react-loader-spinner</td>
          <td>3.1.14</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2018 Mohan Pd. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/mhnpd/react-loader-spinner</td>
        </tr>
        <tr>
          <td>react-popper</td>
          <td>1.3.7</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2018 React Popper authors
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/souporserious/react-popper</td>
        </tr>
        <tr>
          <td>react-promise-tracker</td>
          <td>2.1.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2017 Braulio Diez Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/Lemoncode/react-promise-tracker/tree/2.1.0</td>
        </tr>
        <tr>
          <td>react-redux</td>
          <td>7.2.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015-present Dan Abramov
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/reduxjs/react-redux/tree/v7.2.0</td>
        </tr>
        <tr>
          <td>react-router</td>
          <td>5.1.2</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) React Training 2016-2018 Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ReactTraining/react-router/tree/v5.1.2</td>
        </tr>
        <tr>
          <td>react-router-dom</td>
          <td>5.1.2</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) React Training 2016-2018 Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/ReactTraining/react-router/tree/v5.1.2</td>
        </tr>
        <tr>
          <td>react-select</td>
          <td>3.1.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2018 Jed Watson Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/JedWatson/react-select/tree/react-select%403.1.0
          </td>
        </tr>
        <tr>
          <td>reactstrap</td>
          <td>8.4.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2016-Present Eddy Hernandez,
            Chris Burrell, Evan Sharp Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/reactstrap/reactstrap/tree/8.4.1</td>
        </tr>
        <tr>
          <td>react-transition-group</td>
          <td>1.2.1</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            BSD 3-Clause License Copyright (c) 2016, React Community Forked from
            React (https://github.com/facebook/react) Copyright 2013-present,
            Facebook, Inc. All rights reserved. Redistribution and use in source
            and binary forms, with or without modification, are permitted
            provided that the following conditions are met: * Redistributions of
            source code must retain the above copyright notice, this list of
            conditions and the following disclaimer. * Redistributions in binary
            form must reproduce the above copyright notice, this list of
            conditions and the following disclaimer in the documentation and/or
            other materials provided with the distribution. * Neither the name
            of the copyright holder nor the names of its contributors may be
            used to endorse or promote products derived from this software
            without specific prior written permission. THIS SOFTWARE IS PROVIDED
            BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
            CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
            USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
            OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGE.
          </td>
          <td>https://github.com/reactjs/react-transition-group/tree/v1.2.1</td>
        </tr>
        <tr>
          <td>react-transition-group</td>
          <td>2.9.0</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            BSD 3-Clause License Copyright (c) 2018, React Community Forked from
            React (https://github.com/facebook/react) Copyright 2013-present,
            Facebook, Inc. All rights reserved. Redistribution and use in source
            and binary forms, with or without modification, are permitted
            provided that the following conditions are met: * Redistributions of
            source code must retain the above copyright notice, this list of
            conditions and the following disclaimer. * Redistributions in binary
            form must reproduce the above copyright notice, this list of
            conditions and the following disclaimer in the documentation and/or
            other materials provided with the distribution. * Neither the name
            of the copyright holder nor the names of its contributors may be
            used to endorse or promote products derived from this software
            without specific prior written permission. THIS SOFTWARE IS PROVIDED
            BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
            CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
            USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
            OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGE.
          </td>
          <td>https://github.com/reactjs/react-transition-group/tree/v2.9.0</td>
        </tr>
        <tr>
          <td>react-transition-group</td>
          <td>4.3.0</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            BSD 3-Clause License Copyright (c) 2018, React Community Forked from
            React (https://github.com/facebook/react) Copyright 2013-present,
            Facebook, Inc. All rights reserved. Redistribution and use in source
            and binary forms, with or without modification, are permitted
            provided that the following conditions are met: * Redistributions of
            source code must retain the above copyright notice, this list of
            conditions and the following disclaimer. * Redistributions in binary
            form must reproduce the above copyright notice, this list of
            conditions and the following disclaimer in the documentation and/or
            other materials provided with the distribution. * Neither the name
            of the copyright holder nor the names of its contributors may be
            used to endorse or promote products derived from this software
            without specific prior written permission. THIS SOFTWARE IS PROVIDED
            BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
            CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
            USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
            OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGE.
          </td>
          <td>https://github.com/reactjs/react-transition-group/tree/v4.3.0</td>
        </tr>
        <tr>
          <td>redux</td>
          <td>4.0.5</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015-present Dan Abramov
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/reduxjs/redux/tree/v4.0.5</td>
        </tr>
        <tr>
          <td>redux-devtools-extension</td>
          <td>2.13.8</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015-present Mihail Diordiev
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/zalmoxisus/redux-devtools-extension</td>
        </tr>
        <tr>
          <td>redux-mock-store</td>
          <td>1.5.4</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2017 Arnaud Benard Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/arnaudbenard/redux-mock-store</td>
        </tr>
        <tr>
          <td>redux-thunk</td>
          <td>2.3.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015-present Dan Abramov
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/reduxjs/redux-thunk/tree/v2.3.0</td>
        </tr>
        <tr>
          <td>regenerator-runtime</td>
          <td>0.11.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present, Facebook, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/facebook/regenerator/tree/regenerator-runtime%400.11.1/packages/regenerator-runtime
          </td>
        </tr>
        <tr>
          <td>regenerator-runtime</td>
          <td>0.13.5</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014-present, Facebook, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/facebook/regenerator/tree/regenerator-runtime%400.13.5/packages/regenerator-runtime
          </td>
        </tr>
        <tr>
          <td>regexp.prototype.flags</td>
          <td>1.3.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (C) 2014 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/es-shims/RegExp.prototype.flags/tree/v1.3.0
          </td>
        </tr>
        <tr>
          <td>resolve</td>
          <td>1.15.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2012 James Halliday Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/browserify/resolve/tree/v1.15.0</td>
        </tr>
        <tr>
          <td>resolve-from</td>
          <td>4.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/sindresorhus/resolve-from/tree/v4.0.0</td>
        </tr>
        <tr>
          <td>resolve-pathname</td>
          <td>3.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Michael Jackson 2016-2018 Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/mjackson/resolve-pathname/tree/v3.0.0</td>
        </tr>
        <tr>
          <td>safe-buffer</td>
          <td>5.1.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) Feross Aboukhadijeh Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/feross/safe-buffer/tree/v5.1.2</td>
        </tr>
        <tr>
          <td>scheduler</td>
          <td>0.19.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Facebook, Inc. and its affiliates.
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/facebook/react</td>
        </tr>
        <tr>
          <td>shortid</td>
          <td>2.2.15</td>
          <td>MIT +no-false-attribs license</td>
          <td>
            Copyright (c) Dylan Greene All rights reserved. MIT
            +no-false-attribs License Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. Distributions of all or part of the Software intended to
            be used by the recipients as they would use the unmodified Software,
            containing modifications that substantially alter, remove, or
            disable functionality of the Software, outside of the documented
            configuration mechanisms provided by the Software, shall be modified
            such that the Original Author's bug reporting email addresses and
            urls are either replaced with the contact information of the parties
            responsible for the changes, or removed entirely. THE SOFTWARE IS
            PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED,
            INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
            FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT
            SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
            DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT
            OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
            SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/dylang/shortid/tree/2.2.15</td>
        </tr>
        <tr>
          <td>source-map</td>
          <td>0.5.7</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright (c) 2009-2011, Mozilla Foundation and contributors All
            rights reserved. Redistribution and use in source and binary forms,
            with or without modification, are permitted provided that the
            following conditions are met: * Redistributions of source code must
            retain the above copyright notice, this list of conditions and the
            following disclaimer. * Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. * Neither the names of the Mozilla
            Foundation nor the names of project contributors may be used to
            endorse or promote products derived from this software without
            specific prior written permission. THIS SOFTWARE IS PROVIDED BY THE
            COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR
            CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF
            USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
            ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
            OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
            OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGE.
          </td>
          <td>https://github.com/mozilla/source-map/tree/0.5.7</td>
        </tr>
        <tr>
          <td>string.prototype.trimend</td>
          <td>1.0.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2017 Khaled Al-Ansari Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/es-shims/String.prototype.trimEnd/tree/v1.0.1
          </td>
        </tr>
        <tr>
          <td>string.prototype.trimleft</td>
          <td>2.1.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/es-shims/String.prototype.trimLeft/tree/v2.1.2
          </td>
        </tr>
        <tr>
          <td>string.prototype.trimright</td>
          <td>2.1.2</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jordan Harband Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/es-shims/String.prototype.trimRight/tree/v2.1.2
          </td>
        </tr>
        <tr>
          <td>string.prototype.trimstart</td>
          <td>1.0.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2017 Khaled Al-Ansari Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/es-shims/String.prototype.trimStart/tree/v1.0.1
          </td>
        </tr>
        <tr>
          <td>supports-color</td>
          <td>5.5.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) Sindre Sorhus {'<'}sindresorhus@gmail.com
            {'>'} (sindresorhus.com) Permission is hereby granted, free of
            charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/chalk/supports-color/tree/v5.5.0</td>
        </tr>
        <tr>
          <td>symbol-observable</td>
          <td>1.2.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) Sindre Sorhus {'<'}
            sindresorhus@gmail.com{'>'} (sindresorhus.com) Copyright (c) Ben
            Lesh {'<'}ben@benlesh.com{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/benlesh/symbol-observable/tree/1.2.0</td>
        </tr>
        <tr>
          <td>tiny-invariant</td>
          <td>1.1.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2019 Alexander Reardon Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/alexreardon/tiny-invariant/tree/v1.1.0</td>
        </tr>
        <tr>
          <td>tiny-warning</td>
          <td>1.0.3</td>
          <td>MIT license</td>
          <td>
            MIT License Copyright (c) 2019 Alexander Reardon Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/alexreardon/tiny-warning/tree/v1.0.3</td>
        </tr>
        <tr>
          <td>to-fast-properties</td>
          <td>2.0.0</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2014 Petka Antonov 2015 Sindre Sorhus
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>
            https://github.com/sindresorhus/to-fast-properties/tree/v2.0.0
          </td>
        </tr>
        <tr>
          <td>typed-styles</td>
          <td>0.0.7</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2017 Artur Kenzhaev Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/lttb/typed-styles/tree/v0.0.7</td>
        </tr>
        <tr>
          <td>uncontrollable</td>
          <td>4.1.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Jason Quense Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/jquense/uncontrollable/tree/v4.1.0</td>
        </tr>
        <tr>
          <td>uuid</td>
          <td>3.4.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2010-2016 Robert Kieffer and
            other contributors Permission is hereby granted, free of charge, to
            any person obtaining a copy of this software and associated
            documentation files (the "Software"), to deal in the Software
            without restriction, including without limitation the rights to use,
            copy, modify, merge, publish, distribute, sublicense, and/or sell
            copies of the Software, and to permit persons to whom the Software
            is furnished to do so, subject to the following conditions: The
            above copyright notice and this permission notice shall be included
            in all copies or substantial portions of the Software. THE SOFTWARE
            IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
            IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
            MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/uuidjs/uuid/tree/v3.4.0</td>
        </tr>
        <tr>
          <td>warning</td>
          <td>3.0.0</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            BSD License For React software Copyright (c) 2013-2015, Facebook,
            Inc. All rights reserved. Redistribution and use in source and
            binary forms, with or without modification, are permitted provided
            that the following conditions are met: Redistributions of source
            code must retain the above copyright notice, this list of conditions
            and the following disclaimer. Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. Neither the name Facebook nor the
            names of its contributors may be used to endorse or promote products
            derived from this software without specific prior written
            permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
            CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/BerkeleyTrue/warning/tree/v3.0.0</td>
        </tr>
        <tr>
          <td>warning</td>
          <td>4.0.3</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2013-present, Facebook, Inc. Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/BerkeleyTrue/warning/tree/v4.0.3</td>
        </tr>
        <tr>
          <td>yaml</td>
          <td>1.9.2</td>
          <td>ISC License</td>
          <td>
            Copyright 2018 Eemeli Aro {'<'}eemeli@gmail.com{'>'}
            Permission to use, copy, modify, and/or distribute this software for
            any purpose with or without fee is hereby granted, provided that the
            above copyright notice and this permission notice appear in all
            copies. THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS
            ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
            AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
            DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA
            OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
            TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
            PERFORMANCE OF THIS SOFTWARE.
          </td>
          <td>https://github.com/eemeli/yaml/tree/v1.9.2</td>
        </tr>

        {/* Backend Licenses */}
        <tr>
          <td>aniso8601</td>
          <td>8.0.0</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright (c) 2019, Brandon Nielsen All rights reserved.
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: 1. Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. 2. Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. 3. Neither the name of the copyright holder nor
            the names of its contributors may be used to endorse or promote
            products derived from this software without specific prior written
            permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
            CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://bitbucket.org/nielsenb/aniso8601/src/master/</td>
        </tr>
        <tr>
          <td>attrs</td>
          <td>19.3.0</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Hynek Schlawack Permission
            is hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/python-attrs/attrs/tree/19.3.0</td>
        </tr>
        <tr>
          <td>bcrypt</td>
          <td>3.2.0</td>
          <td>Apache License 2.0</td>
          <td>
            {' '}
            Apache License Version 2.0, January 2004
            http://www.apache.org/licenses/ TERMS AND CONDITIONS FOR USE,
            REPRODUCTION, AND DISTRIBUTION 1. Definitions. "License" shall mean
            the terms and conditions for use, reproduction, and distribution as
            defined by Sections 1 through 9 of this document. "Licensor" shall
            mean the copyright owner or entity authorized by the copyright owner
            that is granting the License. "Legal Entity" shall mean the union of
            the acting entity and all other entities that control, are
            controlled by, or are under common control with that entity. For the
            purposes of this definition, "control" means (i) the power, direct
            or indirect, to cause the direction or management of such entity,
            whether by contract or otherwise, or (ii) ownership of fifty percent
            (50%) or more of the outstanding shares, or (iii) beneficial
            ownership of such entity. "You" (or "Your") shall mean an individual
            or Legal Entity exercising permissions granted by this License.
            "Source" form shall mean the preferred form for making
            modifications, including but not limited to software source code,
            documentation source, and configuration files. "Object" form shall
            mean any form resulting from mechanical transformation or
            translation of a Source form, including but not limited to compiled
            object code, generated documentation, and conversions to other media
            types. "Work" shall mean the work of authorship, whether in Source
            or Object form, made available under the License, as indicated by a
            copyright notice that is included in or attached to the work (an
            example is provided in the Appendix below). "Derivative Works" shall
            mean any work, whether in Source or Object form, that is based on
            (or derived from) the Work and for which the editorial revisions,
            annotations, elaborations, or other modifications represent, as a
            whole, an original work of authorship. For the purposes of this
            License, Derivative Works shall not include works that remain
            separable from, or merely link (or bind by name) to the interfaces
            of, the Work and Derivative Works thereof. "Contribution" shall mean
            any work of authorship, including the original version of the Work
            and any modifications or additions to that Work or Derivative Works
            thereof, that is intentionally submitted to Licensor for inclusion
            in the Work by the copyright owner or by an individual or Legal
            Entity authorized to submit on behalf of the copyright owner. For
            the purposes of this definition, "submitted" means any form of
            electronic, verbal, or written communication sent to the Licensor or
            its representatives, including but not limited to communication on
            electronic mailing lists, source code control systems, and issue
            tracking systems that are managed by, or on behalf of, the Licensor
            for the purpose of discussing and improving the Work, but excluding
            communication that is conspicuously marked or otherwise designated
            in writing by the copyright owner as "Not a Contribution."
            "Contributor" shall mean Licensor and any individual or Legal Entity
            on behalf of whom a Contribution has been received by Licensor and
            subsequently incorporated within the Work. 2. Grant of Copyright
            License. Subject to the terms and conditions of this License, each
            Contributor hereby grants to You a perpetual, worldwide,
            non-exclusive, no-charge, royalty-free, irrevocable copyright
            license to reproduce, prepare Derivative Works of, publicly display,
            publicly perform, sublicense, and distribute the Work and such
            Derivative Works in Source or Object form. 3. Grant of Patent
            License. Subject to the terms and conditions of this License, each
            Contributor hereby grants to You a perpetual, worldwide,
            non-exclusive, no-charge, royalty-free, irrevocable (except as
            stated in this section) patent license to make, have made, use,
            offer to sell, sell, import, and otherwise transfer the Work, where
            such license applies only to those patent claims licensable by such
            Contributor that are necessarily infringed by their Contribution(s)
            alone or by combination of their Contribution(s) with the Work to
            which such Contribution(s) was submitted. If You institute patent
            litigation against any entity (including a cross-claim or
            counterclaim in a lawsuit) alleging that the Work or a Contribution
            incorporated within the Work constitutes direct or contributory
            patent infringement, then any patent licenses granted to You under
            this License for that Work shall terminate as of the date such
            litigation is filed. 4. Redistribution. You may reproduce and
            distribute copies of the Work or Derivative Works thereof in any
            medium, with or without modifications, and in Source or Object form,
            provided that You meet the following conditions: (a) You must give
            any other recipients of the Work or Derivative Works a copy of this
            License; and (b) You must cause any modified files to carry
            prominent notices stating that You changed the files; and (c) You
            must retain, in the Source form of any Derivative Works that You
            distribute, all copyright, patent, trademark, and attribution
            notices from the Source form of the Work, excluding those notices
            that do not pertain to any part of the Derivative Works; and (d) If
            the Work includes a "NOTICE" text file as part of its distribution,
            then any Derivative Works that You distribute must include a
            readable copy of the attribution notices contained within such
            NOTICE file, excluding those notices that do not pertain to any part
            of the Derivative Works, in at least one of the following places:
            within a NOTICE text file distributed as part of the Derivative
            Works; within the Source form or documentation, if provided along
            with the Derivative Works; or, within a display generated by the
            Derivative Works, if and wherever such third-party notices normally
            appear. The contents of the NOTICE file are for informational
            purposes only and do not modify the License. You may add Your own
            attribution notices within Derivative Works that You distribute,
            alongside or as an addendum to the NOTICE text from the Work,
            provided that such additional attribution notices cannot be
            construed as modifying the License. You may add Your own copyright
            statement to Your modifications and may provide additional or
            different license terms and conditions for use, reproduction, or
            distribution of Your modifications, or for any such Derivative Works
            as a whole, provided Your use, reproduction, and distribution of the
            Work otherwise complies with the conditions stated in this License.
            5. Submission of Contributions. Unless You explicitly state
            otherwise, any Contribution intentionally submitted for inclusion in
            the Work by You to the Licensor shall be under the terms and
            conditions of this License, without any additional terms or
            conditions. Notwithstanding the above, nothing herein shall
            supersede or modify the terms of any separate license agreement you
            may have executed with Licensor regarding such Contributions. 6.
            Trademarks. This License does not grant permission to use the trade
            names, trademarks, service marks, or product names of the Licensor,
            except as required for reasonable and customary use in describing
            the origin of the Work and reproducing the content of the NOTICE
            file. 7. Disclaimer of Warranty. Unless required by applicable law
            or agreed to in writing, Licensor provides the Work (and each
            Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT
            WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied,
            including, without limitation, any warranties or conditions of
            TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
            PARTICULAR PURPOSE. You are solely responsible for determining the
            appropriateness of using or redistributing the Work and assume any
            risks associated with Your exercise of permissions under this
            License. 8. Limitation of Liability. In no event and under no legal
            theory, whether in tort (including negligence), contract, or
            otherwise, unless required by applicable law (such as deliberate and
            grossly negligent acts) or agreed to in writing, shall any
            Contributor be liable to You for damages, including any direct,
            indirect, special, incidental, or consequential damages of any
            character arising as a result of this License or out of the use or
            inability to use the Work (including but not limited to damages for
            loss of goodwill, work stoppage, computer failure or malfunction, or
            any and all other commercial damages or losses), even if such
            Contributor has been advised of the possibility of such damages. 9.
            Accepting Warranty or Additional Liability. While redistributing the
            Work or Derivative Works thereof, You may choose to offer, and
            charge a fee for, acceptance of support, warranty, indemnity, or
            other liability obligations and/or rights consistent with this
            License. However, in accepting such obligations, You may act only on
            Your own behalf and on Your sole responsibility, not on behalf of
            any other Contributor, and only if You agree to indemnify, defend,
            and hold each Contributor harmless for any liability incurred by, or
            claims asserted against, such Contributor by reason of your
            accepting any such warranty or additional liability. END OF TERMS
            AND CONDITIONS APPENDIX: How to apply the Apache License to your
            work. To apply the Apache License to your work, attach the following
            boilerplate notice, with the fields enclosed by brackets "[]"
            replaced with your own identifying information. (Don't include the
            brackets!) The text should be enclosed in the appropriate comment
            syntax for the file format. We also recommend that a file or class
            name and description of purpose be included on the same "printed
            page" as the copyright notice for easier identification within
            third-party archives. Copyright [yyyy] [name of copyright owner]
            Licensed under the Apache License, Version 2.0 (the "License"); you
            may not use this file except in compliance with the License. You may
            obtain a copy of the License at
            http://www.apache.org/licenses/LICENSE-2.0 Unless required by
            applicable law or agreed to in writing, software distributed under
            the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
            OR CONDITIONS OF ANY KIND, either express or implied. See the
            License for the specific language governing permissions and
            limitations under the License.
          </td>
          <td>https://github.com/pyca/bcrypt/tree/3.2.0</td>
        </tr>
        <tr>
          <td>click</td>
          <td>7.1.2</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright 2014 Pallets Redistribution and use in source and binary
            forms, with or without modification, are permitted provided that the
            following conditions are met: 1. Redistributions of source code must
            retain the above copyright notice, this list of conditions and the
            following disclaimer. 2. Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. 3. Neither the name of the copyright
            holder nor the names of its contributors may be used to endorse or
            promote products derived from this software without specific prior
            written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT
            HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
            WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/pallets/click/tree/7.1.2</td>
        </tr>
        <tr>
          <td>flask</td>
          <td>1.1.2</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright 2010 Pallets Redistribution and use in source and binary
            forms, with or without modification, are permitted provided that the
            following conditions are met: 1. Redistributions of source code must
            retain the above copyright notice, this list of conditions and the
            following disclaimer. 2. Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. 3. Neither the name of the copyright
            holder nor the names of its contributors may be used to endorse or
            promote products derived from this software without specific prior
            written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT
            HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
            WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/pallets/flask/tree/1.1.2</td>
        </tr>
        <tr>
          <td>flask-cors</td>
          <td>3.0.8</td>
          <td>MIT License</td>
          <td>
            Copyright (C) 2016 Cory Dolphin, Olin College Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/corydolphin/flask-cors/tree/3.0.8</td>
        </tr>
        <tr>
          <td>flask-jwt-extended</td>
          <td>3.24.1</td>
          <td>MIT License</td>
          <td>
            MIT License Copyright (c) 2016 Landon Permission is hereby granted,
            free of charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/vimalloc/flask-jwt-extended/tree/3.24.1</td>
        </tr>
        <tr>
          <td>flask-restx</td>
          <td>0.2.0</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            BSD 3-Clause License Original work Copyright (c) 2013 Twilio, Inc
            Modified work Copyright (c) 2014 Axel Haustant Modified work
            Copyright (c) 2020 python-restx Authors All rights reserved.
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: * Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. * Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. * Neither the name of the copyright holder nor the
            names of its contributors may be used to endorse or promote products
            derived from this software without specific prior written
            permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
            CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/python-restx/flask-restx/tree/0.2.0</td>
        </tr>
        <tr>
          <td>gunicorn</td>
          <td>20.0.4</td>
          <td>MIT License</td>
          <td>
            2009-2018 (c) Benoît Chesneau {'<'}benoitc@e-engura.org{'>'}
            2009-2015 (c) Paul J. Davis {'<'}paul.joseph.davis@gmail.com{'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/benoitc/gunicorn/tree/20.0.4</td>
        </tr>
        <tr>
          <td>itsdangerous</td>
          <td>1.1.0</td>
          <td>Custom License and BSD 3-Clause "New" or "Revised" License</td>
          <td>
            `BSD 3-Clause {'<'}https://opensource.org/licenses/BSD-3-Clause{'>'}
            `_ Copyright © 2011 by the Pallets team. Some rights reserved.
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: - Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. - Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. - Neither the name of the copyright holder nor the
            names of its contributors may be used to endorse or promote products
            derived from this software without specific prior written
            permission. We kindly ask you to use these themes in an unmodified
            manner only with Pallets and Pallets-related projects, not for
            unrelated projects. If you like the visual style and want to use it
            for your own projects, please consider making some larger changes to
            the themes (such as changing font faces, sizes, colors or margins).
            THIS SOFTWARE AND DOCUMENTATION IS PROVIDED BY THE COPYRIGHT HOLDERS
            AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE AND DOCUMENTATION, EVEN IF ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGE. ---- The initial implementation of itsdangerous was
            inspired by Django's signing module. Copyright © Django Software
            Foundation and individual contributors. All rights reserved.
          </td>
          <td>https://github.com/pallets/itsdangerous/tree/1.1.0</td>
        </tr>
        <tr>
          <td>jinja2</td>
          <td>2.11.2</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright 2007 Pallets Redistribution and use in source and binary
            forms, with or without modification, are permitted provided that the
            following conditions are met: 1. Redistributions of source code must
            retain the above copyright notice, this list of conditions and the
            following disclaimer. 2. Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. 3. Neither the name of the copyright
            holder nor the names of its contributors may be used to endorse or
            promote products derived from this software without specific prior
            written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT
            HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
            WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/pallets/jinja/tree/2.11.2</td>
        </tr>
        <tr>
          <td>jsonschema</td>
          <td>3.2.0</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2013 Julian Berman Permission is hereby granted, free
            of charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/Julian/jsonschema/tree/v3.2.0</td>
        </tr>
        <tr>
          <td>markupsafe</td>
          <td>1.1.1</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright 2010 Pallets Redistribution and use in source and binary
            forms, with or without modification, are permitted provided that the
            following conditions are met: 1. Redistributions of source code must
            retain the above copyright notice, this list of conditions and the
            following disclaimer. 2. Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. 3. Neither the name of the copyright
            holder nor the names of its contributors may be used to endorse or
            promote products derived from this software without specific prior
            written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT
            HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
            WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/pallets/markupsafe/tree/1.1.1</td>
        </tr>
        <tr>
          <td>marshmallow</td>
          <td>3.7.1</td>
          <td>MIT License</td>
          <td>
            Copyright 2020 Steven Loria and contributors Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/marshmallow-code/marshmallow/tree/3.7.1</td>
        </tr>
        <tr>
          <td>marshmallow-enum</td>
          <td>1.5.1</td>
          <td>MIt License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 Alec Nikolas Reiter
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/justanr/marshmallow_enum/tree/v1.5.1</td>
        </tr>
        <tr>
          <td>meinheld</td>
          <td>1.0.2</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright (c) Yutaka Matsubara and individual contributors. All
            rights reserved. Redistribution and use in source and binary forms
            of the software as well as documentation, with or without
            modification, are permitted provided that the following conditions
            are met: * Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. * Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. * The names of the contributors may not be used to
            endorse or promote products derived from this software without
            specific prior written permission. THIS SOFTWARE AND DOCUMENTATION
            IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
            ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
            THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
            PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
            OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
            BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
            LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
            ANY WAY OUT OF THE USE OF THIS SOFTWARE AND DOCUMENTATION, EVEN IF
            ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/mopemope/meinheld/tree/v1.0.2</td>
        </tr>
        <tr>
          <td>passlib</td>
          <td>1.7.2</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            .. -*- restructuredtext -*- ===================== Copyrights &
            Licenses ===================== Credits ======= Passlib is primarily
            developed by Eli Collins. Special thanks to Darin Gordon for testing
            and feedback on the :mod:`passlib.totp` module. License for Passlib
            =================== Passlib is (c) `Assurance Technologies {'<'}
            http://www.assurancetechnologies.com{'>'}`_, and is released under
            the `BSD license {'<'}
            http://www.opensource.org/licenses/bsd-license.php{'>'}`_:: Passlib
            Copyright (c) 2008-2019 Assurance Technologies, LLC. All rights
            reserved. Redistribution and use in source and binary forms, with or
            without modification, are permitted provided that the following
            conditions are met: * Redistributions of source code must retain the
            above copyright notice, this list of conditions and the following
            disclaimer. * Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. * Neither the name of Assurance Technologies, nor
            the names of the contributors may be used to endorse or promote
            products derived from this software without specific prior written
            permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND
            CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            Licenses for incorporated software
            ================================== Passlib contains some code
            derived from the following sources: MD5-Crypt --------- The source
            file ``passlib/handlers/md5_crypt.py`` contains code derived from
            the original `FreeBSD md5-crypt implementation {'<'}
            http://www.freebsd.org/cgi/cvsweb.cgi/~checkout~/src/lib/libcrypt/crypt.c?rev=1.2
            {'>'}`_, which is available under the following license:: "THE
            BEER-WARE LICENSE" (Revision 42):
            {'<'}phk@login.dknet.dk{'>'} wrote this file. As long as you retain
            this notice you can do whatever you want with this stuff. If we meet
            some day, and you think this stuff is worth it, you can buy me a
            beer in return. Poul-Henning Kamp converted to python May 2008 by
            Eli Collins DES --- The source file ``passlib/crypto/des.py``
            contains code derived from `UnixCrypt.java {'<'}
            http://www.dynamic.net.au/christos/crypt/UnixCrypt2.txt{'>'}`_, a
            pure-java implementation of the historic unix-crypt password hash
            algorithm. It is available under the following license::
            UnixCrypt.java 0.9 96/11/25 Copyright (c) 1996 Aki Yoshida. All
            rights reserved. Permission to use, copy, modify and distribute this
            software for non-commercial or commercial purposes and without fee
            is hereby granted provided that this copyright notice appears in all
            copies. modified April 2001 by Iris Van den Broeke, Daniel Deville
            modified Aug 2005 by Greg Wilkins (gregw) converted to python Jun
            2009 by Eli Collins jBCrypt ------- The source file
            ``passlib/crypto/_blowfish/base.py`` contains code derived from
            `jBcrypt 0.2 {'<'}http://www.mindrot.org/projects/jBCrypt/{'>'}`_, a
            Java implementation of the BCrypt password hash algorithm. It is
            available under a BSD/ISC license:: Copyright (c) 2006 Damien Miller{' '}
            {'<'}djm@mindrot.org{'>'}
            Permission to use, copy, modify, and distribute this software for
            any purpose with or without fee is hereby granted, provided that the
            above copyright notice and this permission notice appear in all
            copies. THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS
            ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE
            AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL
            DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA
            OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER
            TORTUOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
            PERFORMANCE OF THIS SOFTWARE. Wordsets -------- The EFF wordsets in
            ``passlib/_data/wordsets`` are (c) 2016 the Electronic Freedom
            Foundation. They were downloaded from `{'<'}
            https://www.eff.org/deeplinks/2016/07/new-wordlists-random-passphrases
            {'>'}`_, and are released under the `Creative Commons License {'<'}
            https://www.eff.org/copyright{'>'}`_.
          </td>
          <td>https://foss.heptapod.net/python-libs/passlib/-/tree/1.7.2</td>
        </tr>
        <tr>
          <td>pyjwt</td>
          <td>1.7.1</td>
          <td>MIT License</td>
          <td>
            The MIT License (MIT) Copyright (c) 2015 José Padilla Permission is
            hereby granted, free of charge, to any person obtaining a copy of
            this software and associated documentation files (the "Software"),
            to deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/jpadilla/pyjwt/tree/1.7.1</td>
        </tr>
        <tr>
          <td>pymongo</td>
          <td>3.11.0</td>
          <td>Apache License 2.0</td>
          <td>
            {' '}
            Apache License Version 2.0, January 2004
            http://www.apache.org/licenses/ TERMS AND CONDITIONS FOR USE,
            REPRODUCTION, AND DISTRIBUTION 1. Definitions. "License" shall mean
            the terms and conditions for use, reproduction, and distribution as
            defined by Sections 1 through 9 of this document. "Licensor" shall
            mean the copyright owner or entity authorized by the copyright owner
            that is granting the License. "Legal Entity" shall mean the union of
            the acting entity and all other entities that control, are
            controlled by, or are under common control with that entity. For the
            purposes of this definition, "control" means (i) the power, direct
            or indirect, to cause the direction or management of such entity,
            whether by contract or otherwise, or (ii) ownership of fifty percent
            (50%) or more of the outstanding shares, or (iii) beneficial
            ownership of such entity. "You" (or "Your") shall mean an individual
            or Legal Entity exercising permissions granted by this License.
            "Source" form shall mean the preferred form for making
            modifications, including but not limited to software source code,
            documentation source, and configuration files. "Object" form shall
            mean any form resulting from mechanical transformation or
            translation of a Source form, including but not limited to compiled
            object code, generated documentation, and conversions to other media
            types. "Work" shall mean the work of authorship, whether in Source
            or Object form, made available under the License, as indicated by a
            copyright notice that is included in or attached to the work (an
            example is provided in the Appendix below). "Derivative Works" shall
            mean any work, whether in Source or Object form, that is based on
            (or derived from) the Work and for which the editorial revisions,
            annotations, elaborations, or other modifications represent, as a
            whole, an original work of authorship. For the purposes of this
            License, Derivative Works shall not include works that remain
            separable from, or merely link (or bind by name) to the interfaces
            of, the Work and Derivative Works thereof. "Contribution" shall mean
            any work of authorship, including the original version of the Work
            and any modifications or additions to that Work or Derivative Works
            thereof, that is intentionally submitted to Licensor for inclusion
            in the Work by the copyright owner or by an individual or Legal
            Entity authorized to submit on behalf of the copyright owner. For
            the purposes of this definition, "submitted" means any form of
            electronic, verbal, or written communication sent to the Licensor or
            its representatives, including but not limited to communication on
            electronic mailing lists, source code control systems, and issue
            tracking systems that are managed by, or on behalf of, the Licensor
            for the purpose of discussing and improving the Work, but excluding
            communication that is conspicuously marked or otherwise designated
            in writing by the copyright owner as "Not a Contribution."
            "Contributor" shall mean Licensor and any individual or Legal Entity
            on behalf of whom a Contribution has been received by Licensor and
            subsequently incorporated within the Work. 2. Grant of Copyright
            License. Subject to the terms and conditions of this License, each
            Contributor hereby grants to You a perpetual, worldwide,
            non-exclusive, no-charge, royalty-free, irrevocable copyright
            license to reproduce, prepare Derivative Works of, publicly display,
            publicly perform, sublicense, and distribute the Work and such
            Derivative Works in Source or Object form. 3. Grant of Patent
            License. Subject to the terms and conditions of this License, each
            Contributor hereby grants to You a perpetual, worldwide,
            non-exclusive, no-charge, royalty-free, irrevocable (except as
            stated in this section) patent license to make, have made, use,
            offer to sell, sell, import, and otherwise transfer the Work, where
            such license applies only to those patent claims licensable by such
            Contributor that are necessarily infringed by their Contribution(s)
            alone or by combination of their Contribution(s) with the Work to
            which such Contribution(s) was submitted. If You institute patent
            litigation against any entity (including a cross-claim or
            counterclaim in a lawsuit) alleging that the Work or a Contribution
            incorporated within the Work constitutes direct or contributory
            patent infringement, then any patent licenses granted to You under
            this License for that Work shall terminate as of the date such
            litigation is filed. 4. Redistribution. You may reproduce and
            distribute copies of the Work or Derivative Works thereof in any
            medium, with or without modifications, and in Source or Object form,
            provided that You meet the following conditions: (a) You must give
            any other recipients of the Work or Derivative Works a copy of this
            License; and (b) You must cause any modified files to carry
            prominent notices stating that You changed the files; and (c) You
            must retain, in the Source form of any Derivative Works that You
            distribute, all copyright, patent, trademark, and attribution
            notices from the Source form of the Work, excluding those notices
            that do not pertain to any part of the Derivative Works; and (d) If
            the Work includes a "NOTICE" text file as part of its distribution,
            then any Derivative Works that You distribute must include a
            readable copy of the attribution notices contained within such
            NOTICE file, excluding those notices that do not pertain to any part
            of the Derivative Works, in at least one of the following places:
            within a NOTICE text file distributed as part of the Derivative
            Works; within the Source form or documentation, if provided along
            with the Derivative Works; or, within a display generated by the
            Derivative Works, if and wherever such third-party notices normally
            appear. The contents of the NOTICE file are for informational
            purposes only and do not modify the License. You may add Your own
            attribution notices within Derivative Works that You distribute,
            alongside or as an addendum to the NOTICE text from the Work,
            provided that such additional attribution notices cannot be
            construed as modifying the License. You may add Your own copyright
            statement to Your modifications and may provide additional or
            different license terms and conditions for use, reproduction, or
            distribution of Your modifications, or for any such Derivative Works
            as a whole, provided Your use, reproduction, and distribution of the
            Work otherwise complies with the conditions stated in this License.
            5. Submission of Contributions. Unless You explicitly state
            otherwise, any Contribution intentionally submitted for inclusion in
            the Work by You to the Licensor shall be under the terms and
            conditions of this License, without any additional terms or
            conditions. Notwithstanding the above, nothing herein shall
            supersede or modify the terms of any separate license agreement you
            may have executed with Licensor regarding such Contributions. 6.
            Trademarks. This License does not grant permission to use the trade
            names, trademarks, service marks, or product names of the Licensor,
            except as required for reasonable and customary use in describing
            the origin of the Work and reproducing the content of the NOTICE
            file. 7. Disclaimer of Warranty. Unless required by applicable law
            or agreed to in writing, Licensor provides the Work (and each
            Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT
            WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied,
            including, without limitation, any warranties or conditions of
            TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
            PARTICULAR PURPOSE. You are solely responsible for determining the
            appropriateness of using or redistributing the Work and assume any
            risks associated with Your exercise of permissions under this
            License. 8. Limitation of Liability. In no event and under no legal
            theory, whether in tort (including negligence), contract, or
            otherwise, unless required by applicable law (such as deliberate and
            grossly negligent acts) or agreed to in writing, shall any
            Contributor be liable to You for damages, including any direct,
            indirect, special, incidental, or consequential damages of any
            character arising as a result of this License or out of the use or
            inability to use the Work (including but not limited to damages for
            loss of goodwill, work stoppage, computer failure or malfunction, or
            any and all other commercial damages or losses), even if such
            Contributor has been advised of the possibility of such damages. 9.
            Accepting Warranty or Additional Liability. While redistributing the
            Work or Derivative Works thereof, You may choose to offer, and
            charge a fee for, acceptance of support, warranty, indemnity, or
            other liability obligations and/or rights consistent with this
            License. However, in accepting such obligations, You may act only on
            Your own behalf and on Your sole responsibility, not on behalf of
            any other Contributor, and only if You agree to indemnify, defend,
            and hold each Contributor harmless for any liability incurred by, or
            claims asserted against, such Contributor by reason of your
            accepting any such warranty or additional liability. END OF TERMS
            AND CONDITIONS APPENDIX: How to apply the Apache License to your
            work. To apply the Apache License to your work, attach the following
            boilerplate notice, with the fields enclosed by brackets "[]"
            replaced with your own identifying information. (Don't include the
            brackets!) The text should be enclosed in the appropriate comment
            syntax for the file format. We also recommend that a file or class
            name and description of purpose be included on the same "printed
            page" as the copyright notice for easier identification within
            third-party archives. Copyright [yyyy] [name of copyright owner]
            Licensed under the Apache License, Version 2.0 (the "License"); you
            may not use this file except in compliance with the License. You may
            obtain a copy of the License at
            http://www.apache.org/licenses/LICENSE-2.0 Unless required by
            applicable law or agreed to in writing, software distributed under
            the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
            OR CONDITIONS OF ANY KIND, either express or implied. See the
            License for the specific language governing permissions and
            limitations under the License.
          </td>
          <td>https://github.com/mongodb/mongo-python-driver/tree/3.11.0</td>
        </tr>
        <tr>
          <td>pyrsistent</td>
          <td>0.16.0</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2019 Tobias Gustafsson Permission is hereby granted,
            free of charge, to any person obtaining a copy of this software and
            associated documentation files (the "Software"), to deal in the
            Software without restriction, including without limitation the
            rights to use, copy, modify, merge, publish, distribute, sublicense,
            and/or sell copies of the Software, and to permit persons to whom
            the Software is furnished to do so, subject to the following
            conditions: The above copyright notice and this permission notice
            shall be included in all copies or substantial portions of the
            Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY
            KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE
            WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
            NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS
            BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
            ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
            CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
            SOFTWARE.
          </td>
          <td>https://github.com/tobgu/pyrsistent/tree/v0.16.0</td>
        </tr>
        <tr>
          <td>pytz</td>
          <td>2020.1</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2003-2019 Stuart Bishop {'<'}stuart@stuartbishop.net
            {'>'}
            Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/stub42/pytz/tree/release_2020.1</td>
        </tr>
        <tr>
          <td>six</td>
          <td>1.15.0</td>
          <td>MIT License</td>
          <td>
            Copyright (c) 2010-2020 Benjamin Peterson Permission is hereby
            granted, free of charge, to any person obtaining a copy of this
            software and associated documentation files (the "Software"), to
            deal in the Software without restriction, including without
            limitation the rights to use, copy, modify, merge, publish,
            distribute, sublicense, and/or sell copies of the Software, and to
            permit persons to whom the Software is furnished to do so, subject
            to the following conditions: The above copyright notice and this
            permission notice shall be included in all copies or substantial
            portions of the Software. THE SOFTWARE IS PROVIDED "AS IS", WITHOUT
            WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
            TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
            PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
            COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
            LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
            ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE
            OR OTHER DEALINGS IN THE SOFTWARE.
          </td>
          <td>https://github.com/benjaminp/six/tree/1.15.0</td>
        </tr>
        <tr>
          <td>werkzeug</td>
          <td>1.0.1</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright 2007 Pallets Redistribution and use in source and binary
            forms, with or without modification, are permitted provided that the
            following conditions are met: 1. Redistributions of source code must
            retain the above copyright notice, this list of conditions and the
            following disclaimer. 2. Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. 3. Neither the name of the copyright
            holder nor the names of its contributors may be used to endorse or
            promote products derived from this software without specific prior
            written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT
            HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
            WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/pallets/werkzeug/tree/1.0.1</td>
        </tr>
        <tr>
          <td>flask-mail</td>
          <td>0.9.1</td>
          <td>BSD 3-Clause "New" or "Revised" License</td>
          <td>
            Copyright (c) 2010 by danjac. Some rights reserved. Redistribution
            and use in source and binary forms, with or without modification,
            are permitted provided that the following conditions are met: *
            Redistributions of source code must retain the above copyright
            notice, this list of conditions and the following disclaimer. *
            Redistributions in binary form must reproduce the above copyright
            notice, this list of conditions and the following disclaimer in the
            documentation and/or other materials provided with the distribution.
            * The names of the contributors may not be used to endorse or
            promote products derived from this software without specific prior
            written permission. THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT
            HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
            WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
            ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
            CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
            SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR
            BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
            LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
            NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
            SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/mattupstate/flask-mail/tree/0.9.1</td>
        </tr>
        <tr>
          <td>blinker</td>
          <td>1.4</td>
          <td>MIT License</td>
          <td>
            Copyright (c) The Blinker authors and contributors (see AUTHORS
            file) Permission is hereby granted, free of charge, to any person
            obtaining a copy of this software and associated documentation files
            (the "Software"), to deal in the Software without restriction,
            including without limitation the rights to use, copy, modify, merge,
            publish, distribute, sublicense, and/or sell copies of the Software,
            and to permit persons to whom the Software is furnished to do so,
            subject to the following conditions: The above copyright notice and
            this permission notice shall be included in all copies or
            substantial portions of the Software. THE SOFTWARE IS PROVIDED "AS
            IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT
            NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
            PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
            AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR
            OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
            OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE
            OR THE USE OR OTHER DEALINGS IN THE SOFTWARE. Blinker was originally
            written by Jason Kirtland. Contributors are: - Jason Kirtland {'<'}
            jek@discorporate.us{'>'}
            Blinker includes code from Louie, by Patrick K. O'Brien, Mike C.
            Fletcher, and Matthew R. Scott.
          </td>
          <td>https://github.com/jek/blinker/tree/rel-1.4</td>
        </tr>

        {/* Python Licneses */}
        <tr>
          <td>python</td>
          <td>3.8.5</td>
          <td>Python Software Foundation License 2.0</td>
          <td>
            A. HISTORY OF THE SOFTWARE ========================== Python was
            created in the early 1990s by Guido van Rossum at Stichting
            Mathematisch Centrum (CWI, see http://www.cwi.nl) in the Netherlands
            as a successor of a language called ABC. Guido remains Python's
            principal author, although it includes many contributions from
            others. In 1995, Guido continued his work on Python at the
            Corporation for National Research Initiatives (CNRI, see
            http://www.cnri.reston.va.us) in Reston, Virginia where he released
            several versions of the software. In May 2000, Guido and the Python
            core development team moved to BeOpen.com to form the BeOpen
            PythonLabs team. In October of the same year, the PythonLabs team
            moved to Digital Creations, which became Zope Corporation. In 2001,
            the Python Software Foundation (PSF, see
            https://www.python.org/psf/) was formed, a non-profit organization
            created specifically to own Python-related Intellectual Property.
            Zope Corporation was a sponsoring member of the PSF. All Python
            releases are Open Source (see http://www.opensource.org for the Open
            Source Definition). Historically, most, but not all, Python releases
            have also been GPL-compatible; the table below summarizes the
            various releases. Release Derived Year Owner GPL- from compatible?
            (1) 0.9.0 thru 1.2 1991-1995 CWI yes 1.3 thru 1.5.2 1.2 1995-1999
            CNRI yes 1.6 1.5.2 2000 CNRI no 2.0 1.6 2000 BeOpen.com no 1.6.1 1.6
            2001 CNRI yes (2) 2.1 2.0+1.6.1 2001 PSF no 2.0.1 2.0+1.6.1 2001 PSF
            yes 2.1.1 2.1+2.0.1 2001 PSF yes 2.1.2 2.1.1 2002 PSF yes 2.1.3
            2.1.2 2002 PSF yes 2.2 and above 2.1.1 2001-now PSF yes Footnotes:
            (1) GPL-compatible doesn't mean that we're distributing Python under
            the GPL. All Python licenses, unlike the GPL, let you distribute a
            modified version without making your changes open source. The
            GPL-compatible licenses make it possible to combine Python with
            other software that is released under the GPL; the others don't. (2)
            According to Richard Stallman, 1.6.1 is not GPL-compatible, because
            its license has a choice of law clause. According to CNRI, however,
            Stallman's lawyer has told CNRI's lawyer that 1.6.1 is "not
            incompatible" with the GPL. Thanks to the many outside volunteers
            who have worked under Guido's direction to make these releases
            possible. B. TERMS AND CONDITIONS FOR ACCESSING OR OTHERWISE USING
            PYTHON
            ===============================================================
            PYTHON SOFTWARE FOUNDATION LICENSE VERSION 2
            -------------------------------------------- 1. This LICENSE
            AGREEMENT is between the Python Software Foundation ("PSF"), and the
            Individual or Organization ("Licensee") accessing and otherwise
            using this software ("Python") in source or binary form and its
            associated documentation. 2. Subject to the terms and conditions of
            this License Agreement, PSF hereby grants Licensee a nonexclusive,
            royalty-free, world-wide license to reproduce, analyze, test,
            perform and/or display publicly, prepare derivative works,
            distribute, and otherwise use Python alone or in any derivative
            version, provided, however, that PSF's License Agreement and PSF's
            notice of copyright, i.e., "Copyright (c) 2001, 2002, 2003, 2004,
            2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015,
            2016, 2017, 2018, 2019, 2020 Python Software Foundation; All Rights
            Reserved" are retained in Python alone or in any derivative version
            prepared by Licensee. 3. In the event Licensee prepares a derivative
            work that is based on or incorporates Python or any part thereof,
            and wants to make the derivative work available to others as
            provided herein, then Licensee hereby agrees to include in any such
            work a brief summary of the changes made to Python. 4. PSF is making
            Python available to Licensee on an "AS IS" basis. PSF MAKES NO
            REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED. BY WAY OF
            EXAMPLE, BUT NOT LIMITATION, PSF MAKES NO AND DISCLAIMS ANY
            REPRESENTATION OR WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY
            PARTICULAR PURPOSE OR THAT THE USE OF PYTHON WILL NOT INFRINGE ANY
            THIRD PARTY RIGHTS. 5. PSF SHALL NOT BE LIABLE TO LICENSEE OR ANY
            OTHER USERS OF PYTHON FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL
            DAMAGES OR LOSS AS A RESULT OF MODIFYING, DISTRIBUTING, OR OTHERWISE
            USING PYTHON, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE
            POSSIBILITY THEREOF. 6. This License Agreement will automatically
            terminate upon a material breach of its terms and conditions. 7.
            Nothing in this License Agreement shall be deemed to create any
            relationship of agency, partnership, or joint venture between PSF
            and Licensee. This License Agreement does not grant permission to
            use PSF trademarks or trade name in a trademark sense to endorse or
            promote products or services of Licensee, or any third party. 8. By
            copying, installing or otherwise using Python, Licensee agrees to be
            bound by the terms and conditions of this License Agreement.
            BEOPEN.COM LICENSE AGREEMENT FOR PYTHON 2.0
            ------------------------------------------- BEOPEN PYTHON OPEN
            SOURCE LICENSE AGREEMENT VERSION 1 1. This LICENSE AGREEMENT is
            between BeOpen.com ("BeOpen"), having an office at 160 Saratoga
            Avenue, Santa Clara, CA 95051, and the Individual or Organization
            ("Licensee") accessing and otherwise using this software in source
            or binary form and its associated documentation ("the Software"). 2.
            Subject to the terms and conditions of this BeOpen Python License
            Agreement, BeOpen hereby grants Licensee a non-exclusive,
            royalty-free, world-wide license to reproduce, analyze, test,
            perform and/or display publicly, prepare derivative works,
            distribute, and otherwise use the Software alone or in any
            derivative version, provided, however, that the BeOpen Python
            License is retained in the Software, alone or in any derivative
            version prepared by Licensee. 3. BeOpen is making the Software
            available to Licensee on an "AS IS" basis. BEOPEN MAKES NO
            REPRESENTATIONS OR WARRANTIES, EXPRESS OR IMPLIED. BY WAY OF
            EXAMPLE, BUT NOT LIMITATION, BEOPEN MAKES NO AND DISCLAIMS ANY
            REPRESENTATION OR WARRANTY OF MERCHANTABILITY OR FITNESS FOR ANY
            PARTICULAR PURPOSE OR THAT THE USE OF THE SOFTWARE WILL NOT INFRINGE
            ANY THIRD PARTY RIGHTS. 4. BEOPEN SHALL NOT BE LIABLE TO LICENSEE OR
            ANY OTHER USERS OF THE SOFTWARE FOR ANY INCIDENTAL, SPECIAL, OR
            CONSEQUENTIAL DAMAGES OR LOSS AS A RESULT OF USING, MODIFYING OR
            DISTRIBUTING THE SOFTWARE, OR ANY DERIVATIVE THEREOF, EVEN IF
            ADVISED OF THE POSSIBILITY THEREOF. 5. This License Agreement will
            automatically terminate upon a material breach of its terms and
            conditions. 6. This License Agreement shall be governed by and
            interpreted in all respects by the law of the State of California,
            excluding conflict of law provisions. Nothing in this License
            Agreement shall be deemed to create any relationship of agency,
            partnership, or joint venture between BeOpen and Licensee. This
            License Agreement does not grant permission to use BeOpen trademarks
            or trade names in a trademark sense to endorse or promote products
            or services of Licensee, or any third party. As an exception, the
            "BeOpen Python" logos available at
            http://www.pythonlabs.com/logos.html may be used according to the
            permissions granted on that web page. 7. By copying, installing or
            otherwise using the software, Licensee agrees to be bound by the
            terms and conditions of this License Agreement. CNRI LICENSE
            AGREEMENT FOR PYTHON 1.6.1 ---------------------------------------
            1. This LICENSE AGREEMENT is between the Corporation for National
            Research Initiatives, having an office at 1895 Preston White Drive,
            Reston, VA 20191 ("CNRI"), and the Individual or Organization
            ("Licensee") accessing and otherwise using Python 1.6.1 software in
            source or binary form and its associated documentation. 2. Subject
            to the terms and conditions of this License Agreement, CNRI hereby
            grants Licensee a nonexclusive, royalty-free, world-wide license to
            reproduce, analyze, test, perform and/or display publicly, prepare
            derivative works, distribute, and otherwise use Python 1.6.1 alone
            or in any derivative version, provided, however, that CNRI's License
            Agreement and CNRI's notice of copyright, i.e., "Copyright (c)
            1995-2001 Corporation for National Research Initiatives; All Rights
            Reserved" are retained in Python 1.6.1 alone or in any derivative
            version prepared by Licensee. Alternately, in lieu of CNRI's License
            Agreement, Licensee may substitute the following text (omitting the
            quotes): "Python 1.6.1 is made available subject to the terms and
            conditions in CNRI's License Agreement. This Agreement together with
            Python 1.6.1 may be located on the Internet using the following
            unique, persistent identifier (known as a handle): 1895.22/1013.
            This Agreement may also be obtained from a proxy server on the
            Internet using the following URL:
            http://hdl.handle.net/1895.22/1013". 3. In the event Licensee
            prepares a derivative work that is based on or incorporates Python
            1.6.1 or any part thereof, and wants to make the derivative work
            available to others as provided herein, then Licensee hereby agrees
            to include in any such work a brief summary of the changes made to
            Python 1.6.1. 4. CNRI is making Python 1.6.1 available to Licensee
            on an "AS IS" basis. CNRI MAKES NO REPRESENTATIONS OR WARRANTIES,
            EXPRESS OR IMPLIED. BY WAY OF EXAMPLE, BUT NOT LIMITATION, CNRI
            MAKES NO AND DISCLAIMS ANY REPRESENTATION OR WARRANTY OF
            MERCHANTABILITY OR FITNESS FOR ANY PARTICULAR PURPOSE OR THAT THE
            USE OF PYTHON 1.6.1 WILL NOT INFRINGE ANY THIRD PARTY RIGHTS. 5.
            CNRI SHALL NOT BE LIABLE TO LICENSEE OR ANY OTHER USERS OF PYTHON
            1.6.1 FOR ANY INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES OR LOSS
            AS A RESULT OF MODIFYING, DISTRIBUTING, OR OTHERWISE USING PYTHON
            1.6.1, OR ANY DERIVATIVE THEREOF, EVEN IF ADVISED OF THE POSSIBILITY
            THEREOF. 6. This License Agreement will automatically terminate upon
            a material breach of its terms and conditions. 7. This License
            Agreement shall be governed by the federal intellectual property law
            of the United States, including without limitation the federal
            copyright law, and, to the extent such U.S. federal law does not
            apply, by the law of the Commonwealth of Virginia, excluding
            Virginia's conflict of law provisions. Notwithstanding the
            foregoing, with regard to derivative works based on Python 1.6.1
            that incorporate non-separable material that was previously
            distributed under the GNU General Public License (GPL), the law of
            the Commonwealth of Virginia shall govern this License Agreement
            only as to issues arising under or with respect to Paragraphs 4, 5,
            and 7 of this License Agreement. Nothing in this License Agreement
            shall be deemed to create any relationship of agency, partnership,
            or joint venture between CNRI and Licensee. This License Agreement
            does not grant permission to use CNRI trademarks or trade name in a
            trademark sense to endorse or promote products or services of
            Licensee, or any third party. 8. By clicking on the "ACCEPT" button
            where indicated, or by copying, installing or otherwise using Python
            1.6.1, Licensee agrees to be bound by the terms and conditions of
            this License Agreement. ACCEPT CWI LICENSE AGREEMENT FOR PYTHON
            0.9.0 THROUGH 1.2 --------------------------------------------------
            Copyright (c) 1991 - 1995, Stichting Mathematisch Centrum Amsterdam,
            The Netherlands. All rights reserved. Permission to use, copy,
            modify, and distribute this software and its documentation for any
            purpose and without fee is hereby granted, provided that the above
            copyright notice appear in all copies and that both that copyright
            notice and this permission notice appear in supporting
            documentation, and that the name of Stichting Mathematisch Centrum
            or CWI not be used in advertising or publicity pertaining to
            distribution of the software without specific, written prior
            permission. STICHTING MATHEMATISCH CENTRUM DISCLAIMS ALL WARRANTIES
            WITH REGARD TO THIS SOFTWARE, INCLUDING ALL IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS, IN NO EVENT SHALL STICHTING
            MATHEMATISCH CENTRUM BE LIABLE FOR ANY SPECIAL, INDIRECT OR
            CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS
            OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT,
            NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION
            WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
          </td>
          <td>https://github.com/python/cpython/tree/v3.8.5</td>
        </tr>
        <tr>
          <td>base64</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>hashlib</td>
          <td>20181119</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>json</td>
          <td>2.0.9</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>datetime</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td>re</td>
          <td>2.2.1</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>

        {/* Mongo Licenses */}
        <tr>
          <td>MongoDB Database Server and Tools</td>
          <td>4.2.1</td>
          <td>Server Side Public License, v 1</td>
          <td>
            Server Side Public License VERSION 1, OCTOBER 16, 2018 Copyright ©
            2018 MongoDB, Inc. Everyone is permitted to copy and distribute
            verbatim copies of this license document, but changing it is not
            allowed. TERMS AND CONDITIONS 0. Definitions. "This License" refers
            to Server Side Public License. "Copyright" also means copyright-like
            laws that apply to other kinds of works, such as semiconductor
            masks. "The Program" refers to any copyrightable work licensed under
            this License. Each licensee is addressed as "you". "Licensees" and
            "recipients" may be individuals or organizations. To "modify" a work
            means to copy from or adapt all or part of the work in a fashion
            requiring copyright permission, other than the making of an exact
            copy. The resulting work is called a "modified version" of the
            earlier work or a work "based on" the earlier work. A "covered work"
            means either the unmodified Program or a work based on the Program.
            To "propagate" a work means to do anything with it that, without
            permission, would make you directly or secondarily liable for
            infringement under applicable copyright law, except executing it on
            a computer or modifying a private copy. Propagation includes
            copying, distribution (with or without modification), making
            available to the public, and in some countries other activities as
            well. To "convey" a work means any kind of propagation that enables
            other parties to make or receive copies. Mere interaction with a
            user through a computer network, with no transfer of a copy, is not
            conveying. An interactive user interface displays "Appropriate Legal
            Notices" to the extent that it includes a convenient and prominently
            visible feature that (1) displays an appropriate copyright notice,
            and (2) tells the user that there is no warranty for the work
            (except to the extent that warranties are provided), that licensees
            may convey the work under this License, and how to view a copy of
            this License. If the interface presents a list of user commands or
            options, such as a menu, a prominent item in the list meets this
            criterion. 1. Source Code. The "source code" for a work means the
            preferred form of the work for making modifications to it. "Object
            code" means any non-source form of a work. A "Standard Interface"
            means an interface that either is an official standard defined by a
            recognized standards body, or, in the case of interfaces specified
            for a particular programming language, one that is widely used among
            developers working in that language. The "System Libraries" of an
            executable work include anything, other than the work as a whole,
            that (a) is included in the normal form of packaging a Major
            Component, but which is not part of that Major Component, and (b)
            serves only to enable use of the work with that Major Component, or
            to implement a Standard Interface for which an implementation is
            available to the public in source code form. A "Major Component", in
            this context, means a major essential component (kernel, window
            system, and so on) of the specific operating system (if any) on
            which the executable work runs, or a compiler used to produce the
            work, or an object code interpreter used to run it. The
            "Corresponding Source" for a work in object code form means all the
            source code needed to generate, install, and (for an executable
            work) run the object code and to modify the work, including scripts
            to control those activities. However, it does not include the work's
            System Libraries, or general-purpose tools or generally available
            free programs which are used unmodified in performing those
            activities but which are not part of the work. For example,
            Corresponding Source includes interface definition files associated
            with source files for the work, and the source code for shared
            libraries and dynamically linked subprograms that the work is
            specifically designed to require, such as by intimate data
            communication or control flow between those subprograms and other
            parts of the work. The Corresponding Source need not include
            anything that users can regenerate automatically from other parts of
            the Corresponding Source. The Corresponding Source for a work in
            source code form is that same work. 2. Basic Permissions. All rights
            granted under this License are granted for the term of copyright on
            the Program, and are irrevocable provided the stated conditions are
            met. This License explicitly affirms your unlimited permission to
            run the unmodified Program, subject to section 13. The output from
            running a covered work is covered by this License only if the
            output, given its content, constitutes a covered work. This License
            acknowledges your rights of fair use or other equivalent, as
            provided by copyright law. Subject to section 13, you may make, run
            and propagate covered works that you do not convey, without
            conditions so long as your license otherwise remains in force. You
            may convey covered works to others for the sole purpose of having
            them make modifications exclusively for you, or provide you with
            facilities for running those works, provided that you comply with
            the terms of this License in conveying all material for which you do
            not control copyright. Those thus making or running the covered
            works for you must do so exclusively on your behalf, under your
            direction and control, on terms that prohibit them from making any
            copies of your copyrighted material outside their relationship with
            you. Conveying under any other circumstances is permitted solely
            under the conditions stated below. Sublicensing is not allowed;
            section 10 makes it unnecessary. 3. Protecting Users' Legal Rights
            From Anti-Circumvention Law. No covered work shall be deemed part of
            an effective technological measure under any applicable law
            fulfilling obligations under article 11 of the WIPO copyright treaty
            adopted on 20 December 1996, or similar laws prohibiting or
            restricting circumvention of such measures. When you convey a
            covered work, you waive any legal power to forbid circumvention of
            technological measures to the extent such circumvention is effected
            by exercising rights under this License with respect to the covered
            work, and you disclaim any intention to limit operation or
            modification of the work as a means of enforcing, against the work's
            users, your or third parties' legal rights to forbid circumvention
            of technological measures. 4. Conveying Verbatim Copies. You may
            convey verbatim copies of the Program's source code as you receive
            it, in any medium, provided that you conspicuously and appropriately
            publish on each copy an appropriate copyright notice; keep intact
            all notices stating that this License and any non-permissive terms
            added in accord with section 7 apply to the code; keep intact all
            notices of the absence of any warranty; and give all recipients a
            copy of this License along with the Program. You may charge any
            price or no price for each copy that you convey, and you may offer
            support or warranty protection for a fee. 5. Conveying Modified
            Source Versions. You may convey a work based on the Program, or the
            modifications to produce it from the Program, in the form of source
            code under the terms of section 4, provided that you also meet all
            of these conditions: a) The work must carry prominent notices
            stating that you modified it, and giving a relevant date. b) The
            work must carry prominent notices stating that it is released under
            this License and any conditions added under section 7. This
            requirement modifies the requirement in section 4 to "keep intact
            all notices". c)You must license the entire work, as a whole, under
            this License to anyone who comes into possession of a copy. This
            License will therefore apply, along with any applicable section 7
            additional terms, to the whole of the work, and all its parts,
            regardless of how they are packaged. This License gives no
            permission to license the work in any other way, but it does not
            invalidate such permission if you have separately received it. d)If
            the work has interactive user interfaces, each must display
            Appropriate Legal Notices; however, if the Program has interactive
            interfaces that do not display Appropriate Legal Notices, your work
            need not make them do so. A compilation of a covered work with other
            separate and independent works, which are not by their nature
            extensions of the covered work, and which are not combined with it
            such as to form a larger program, in or on a volume of a storage or
            distribution medium, is called an "aggregate" if the compilation and
            its resulting copyright are not used to limit the access or legal
            rights of the compilation's users beyond what the individual works
            permit. Inclusion of a covered work in an aggregate does not cause
            this License to apply to the other parts of the aggregate. 6.
            Conveying Non-Source Forms. You may convey a covered work in object
            code form under the terms of sections 4 and 5, provided that you
            also convey the machine-readable Corresponding Source under the
            terms of this License, in one of these ways: a) Convey the object
            code in, or embodied in, a physical product (including a physical
            distribution medium), accompanied by the Corresponding Source fixed
            on a durable physical medium customarily used for software
            interchange. b) Convey the object code in, or embodied in, a
            physical product (including a physical distribution medium),
            accompanied by a written offer, valid for at least three years and
            valid for as long as you offer spare parts or customer support for
            that product model, to give anyone who possesses the object code
            either (1) a copy of the Corresponding Source for all the software
            in the product that is covered by this License, on a durable
            physical medium customarily used for software interchange, for a
            price no more than your reasonable cost of physically performing
            this conveying of source, or (2) access to copy the Corresponding
            Source from a network server at no charge. c) Convey individual
            copies of the object code with a copy of the written offer to
            provide the Corresponding Source. This alternative is allowed only
            occasionally and noncommercially, and only if you received the
            object code with such an offer, in accord with subsection 6b. d)
            Convey the object code by offering access from a designated place
            (gratis or for a charge), and offer equivalent access to the
            Corresponding Source in the same way through the same place at no
            further charge. You need not require recipients to copy the
            Corresponding Source along with the object code. If the place to
            copy the object code is a network server, the Corresponding Source
            may be on a different server (operated by you or a third party) that
            supports equivalent copying facilities, provided you maintain clear
            directions next to the object code saying where to find the
            Corresponding Source. Regardless of what server hosts the
            Corresponding Source, you remain obligated to ensure that it is
            available for as long as needed to satisfy these requirements. e)
            Convey the object code using peer-to-peer transmission, provided you
            inform other peers where the object code and Corresponding Source of
            the work are being offered to the general public at no charge under
            subsection 6d. A separable portion of the object code, whose source
            code is excluded from the Corresponding Source as a System Library,
            need not be included in conveying the object code work. A "User
            Product" is either (1) a "consumer product", which means any
            tangible personal property which is normally used for personal,
            family, or household purposes, or (2) anything designed or sold for
            incorporation into a dwelling. In determining whether a product is a
            consumer product, doubtful cases shall be resolved in favor of
            coverage. For a particular product received by a particular user,
            "normally used" refers to a typical or common use of that class of
            product, regardless of the status of the particular user or of the
            way in which the particular user actually uses, or expects or is
            expected to use, the product. A product is a consumer product
            regardless of whether the product has substantial commercial,
            industrial or non-consumer uses, unless such uses represent the only
            significant mode of use of the product. "Installation Information"
            for a User Product means any methods, procedures, authorization
            keys, or other information required to install and execute modified
            versions of a covered work in that User Product from a modified
            version of its Corresponding Source. The information must suffice to
            ensure that the continued functioning of the modified object code is
            in no case prevented or interfered with solely because modification
            has been made. If you convey an object code work under this section
            in, or with, or specifically for use in, a User Product, and the
            conveying occurs as part of a transaction in which the right of
            possession and use of the User Product is transferred to the
            recipient in perpetuity or for a fixed term (regardless of how the
            transaction is characterized), the Corresponding Source conveyed
            under this section must be accompanied by the Installation
            Information. But this requirement does not apply if neither you nor
            any third party retains the ability to install modified object code
            on the User Product (for example, the work has been installed in
            ROM). The requirement to provide Installation Information does not
            include a requirement to continue to provide support service,
            warranty, or updates for a work that has been modified or installed
            by the recipient, or for the User Product in which it has been
            modified or installed. Access to a network may be denied when the
            modification itself materially and adversely affects the operation
            of the network or violates the rules and protocols for communication
            across the network. Corresponding Source conveyed, and Installation
            Information provided, in accord with this section must be in a
            format that is publicly documented (and with an implementation
            available to the public in source code form), and must require no
            special password or key for unpacking, reading or copying. 7.
            Additional Terms. "Additional permissions" are terms that supplement
            the terms of this License by making exceptions from one or more of
            its conditions. Additional permissions that are applicable to the
            entire Program shall be treated as though they were included in this
            License, to the extent that they are valid under applicable law. If
            additional permissions apply only to part of the Program, that part
            may be used separately under those permissions, but the entire
            Program remains governed by this License without regard to the
            additional permissions. When you convey a copy of a covered work,
            you may at your option remove any additional permissions from that
            copy, or from any part of it. (Additional permissions may be written
            to require their own removal in certain cases when you modify the
            work.) You may place additional permissions on material, added by
            you to a covered work, for which you have or can give appropriate
            copyright permission. Notwithstanding any other provision of this
            License, for material you add to a covered work, you may (if
            authorized by the copyright holders of that material) supplement the
            terms of this License with terms: a)Disclaiming warranty or limiting
            liability differently from the terms of sections 15 and 16 of this
            License; or b) Requiring preservation of specified reasonable legal
            notices or author attributions in that material or in the
            Appropriate Legal Notices displayed by works containing it; or c)
            Prohibiting misrepresentation of the origin of that material, or
            requiring that modified versions of such material be marked in
            reasonable ways as different from the original version; or d)
            Limiting the use for publicity purposes of names of licensors or
            authors of the material; or e) Declining to grant rights under
            trademark law for use of some trade names, trademarks, or service
            marks; or f) Requiring indemnification of licensors and authors of
            that material by anyone who conveys the material (or modified
            versions of it) with contractual assumptions of liability to the
            recipient, for any liability that these contractual assumptions
            directly impose on those licensors and authors. All other
            non-permissive additional terms are considered "further
            restrictions" within the meaning of section 10. If the Program as
            you received it, or any part of it, contains a notice stating that
            it is governed by this License along with a term that is a further
            restriction, you may remove that term. If a license document
            contains a further restriction but permits relicensing or conveying
            under this License, you may add to a covered work material governed
            by the terms of that license document, provided that the further
            restriction does not survive such relicensing or conveying. If you
            add terms to a covered work in accord with this section, you must
            place, in the relevant source files, a statement of the additional
            terms that apply to those files, or a notice indicating where to
            find the applicable terms. Additional terms, permissive or
            non-permissive, may be stated in the form of a separately written
            license, or stated as exceptions; the above requirements apply
            either way. 8.Termination. You may not propagate or modify a covered
            work except as expressly provided under this License. Any attempt
            otherwise to propagate or modify it is void, and will automatically
            terminate your rights under this License (including any patent
            licenses granted under the third paragraph of section 11). However,
            if you cease all violation of this License, then your license from a
            particular copyright holder is reinstated (a) provisionally, unless
            and until the copyright holder explicitly and finally terminates
            your license, and (b) permanently, if the copyright holder fails to
            notify you of the violation by some reasonable means prior to 60
            days after the cessation. Moreover, your license from a particular
            copyright holder is reinstated permanently if the copyright holder
            notifies you of the violation by some reasonable means, this is the
            first time you have received notice of violation of this License
            (for any work) from that copyright holder, and you cure the
            violation prior to 30 days after your receipt of the notice.
            Termination of your rights under this section does not terminate the
            licenses of parties who have received copies or rights from you
            under this License. If your rights have been terminated and not
            permanently reinstated, you do not qualify to receive new licenses
            for the same material under section 10. 9. Acceptance Not Required
            for Having Copies. You are not required to accept this License in
            order to receive or run a copy of the Program. Ancillary propagation
            of a covered work occurring solely as a consequence of using
            peer-to-peer transmission to receive a copy likewise does not
            require acceptance. However, nothing other than this License grants
            you permission to propagate or modify any covered work. These
            actions infringe copyright if you do not accept this License.
            Therefore, by modifying or propagating a covered work, you indicate
            your acceptance of this License to do so. 10. Automatic Licensing of
            Downstream Recipients. Each time you convey a covered work, the
            recipient automatically receives a license from the original
            licensors, to run, modify and propagate that work, subject to this
            License. You are not responsible for enforcing compliance by third
            parties with this License. An "entity transaction" is a transaction
            transferring control of an organization, or substantially all assets
            of one, or subdividing an organization, or merging organizations. If
            propagation of a covered work results from an entity transaction,
            each party to that transaction who receives a copy of the work also
            receives whatever licenses to the work the party's predecessor in
            interest had or could give under the previous paragraph, plus a
            right to possession of the Corresponding Source of the work from the
            predecessor in interest, if the predecessor has it or can get it
            with reasonable efforts. You may not impose any further restrictions
            on the exercise of the rights granted or affirmed under this
            License. For example, you may not impose a license fee, royalty, or
            other charge for exercise of rights granted under this License, and
            you may not initiate litigation (including a cross-claim or
            counterclaim in a lawsuit) alleging that any patent claim is
            infringed by making, using, selling, offering for sale, or importing
            the Program or any portion of it. 11. Patents. A "contributor" is a
            copyright holder who authorizes use under this License of the
            Program or a work on which the Program is based. The work thus
            licensed is called the contributor's "contributor version". A
            contributor's "essential patent claims" are all patent claims owned
            or controlled by the contributor, whether already acquired or
            hereafter acquired, that would be infringed by some manner,
            permitted by this License, of making, using, or selling its
            contributor version, but do not include claims that would be
            infringed only as a consequence of further modification of the
            contributor version. For purposes of this definition, "control"
            includes the right to grant patent sublicenses in a manner
            consistent with the requirements of this License. Each contributor
            grants you a non-exclusive, worldwide, royalty-free patent license
            under the contributor's essential patent claims, to make, use, sell,
            offer for sale, import and otherwise run, modify and propagate the
            contents of its contributor version. In the following three
            paragraphs, a "patent license" is any express agreement or
            commitment, however denominated, not to enforce a patent (such as an
            express permission to practice a patent or covenant not to sue for
            patent infringement). To "grant" such a patent license to a party
            means to make such an agreement or commitment not to enforce a
            patent against the party. If you convey a covered work, knowingly
            relying on a patent license, and the Corresponding Source of the
            work is not available for anyone to copy, free of charge and under
            the terms of this License, through a publicly available network
            server or other readily accessible means, then you must either (1)
            cause the Corresponding Source to be so available, or (2) arrange to
            deprive yourself of the benefit of the patent license for this
            particular work, or (3) arrange, in a manner consistent with the
            requirements of this License, to extend the patent license to
            downstream recipients. "Knowingly relying" means you have actual
            knowledge that, but for the patent license, your conveying the
            covered work in a country, or your recipient's use of the covered
            work in a country, would infringe one or more identifiable patents
            in that country that you have reason to believe are valid. If,
            pursuant to or in connection with a single transaction or
            arrangement, you convey, or propagate by procuring conveyance of, a
            covered work, and grant a patent license to some of the parties
            receiving the covered work authorizing them to use, propagate,
            modify or convey a specific copy of the covered work, then the
            patent license you grant is automatically extended to all recipients
            of the covered work and works based on it. A patent license is
            "discriminatory" if it does not include within the scope of its
            coverage, prohibits the exercise of, or is conditioned on the
            non-exercise of one or more of the rights that are specifically
            granted under this License. You may not convey a covered work if you
            are a party to an arrangement with a third party that is in the
            business of distributing software, under which you make payment to
            the third party based on the extent of your activity of conveying
            the work, and under which the third party grants, to any of the
            parties who would receive the covered work from you, a
            discriminatory patent license (a) in connection with copies of the
            covered work conveyed by you (or copies made from those copies), or
            (b) primarily for and in connection with specific products or
            compilations that contain the covered work, unless you entered into
            that arrangement, or that patent license was granted, prior to 28
            March 2007. Nothing in this License shall be construed as excluding
            or limiting any implied license or other defenses to infringement
            that may otherwise be available to you under applicable patent law.
            12. No Surrender of Others' Freedom. If conditions are imposed on
            you (whether by court order, agreement or otherwise) that contradict
            the conditions of this License, they do not excuse you from the
            conditions of this License. If you cannot use, propagate or convey a
            covered work so as to satisfy simultaneously your obligations under
            this License and any other pertinent obligations, then as a
            consequence you may not use, propagate or convey it at all. For
            example, if you agree to terms that obligate you to collect a
            royalty for further conveying from those to whom you convey the
            Program, the only way you could satisfy both those terms and this
            License would be to refrain entirely from conveying the Program. 13.
            Offering the Program as a Service. If you make the functionality of
            the Program or a modified version available to third parties as a
            service, you must make the Service Source Code available via network
            download to everyone at no charge, under the terms of this License.
            Making the functionality of the Program or modified version
            available to third parties as a service includes, without
            limitation, enabling third parties to interact with the
            functionality of the Program or modified version remotely through a
            computer network, offering a service the value of which entirely or
            primarily derives from the value of the Program or modified version,
            or offering a service that accomplishes for users the primary
            purpose of the Program or modified version. "Service Source Code"
            means the Corresponding Source for the Program or the modified
            version, and the Corresponding Source for all programs that you use
            to make the Program or modified version available as a service,
            including, without limitation, management software, user interfaces,
            application program interfaces, automation software, monitoring
            software, backup software, storage software and hosting software,
            all such that a user could run an instance of the service using the
            Service Source Code you make available. 14. Revised Versions of this
            License. MongoDB, Inc. may publish revised and/or new versions of
            the Server Side Public License from time to time. Such new versions
            will be similar in spirit to the present version, but may differ in
            detail to address new problems or concerns. Each version is given a
            distinguishing version number. If the Program specifies that a
            certain numbered version of the Server Side Public License "or any
            later version" applies to it, you have the option of following the
            terms and conditions either of that numbered version or of any later
            version published by MongoDB, Inc. If the Program does not specify a
            version number of the Server Side Public License, you may choose any
            version ever published by MongoDB, Inc. If the Program specifies
            that a proxy can decide which future versions of the Server Side
            Public License can be used, that proxy's public statement of
            acceptance of a version permanently authorizes you to choose that
            version for the Program. Later license versions may give you
            additional or different permissions. However, no additional
            obligations are imposed on any author or copyright holder as a
            result of your choosing to follow a later version. 15. Disclaimer of
            Warranty. THERE IS NO WARRANTY FOR THE PROGRAM, TO THE EXTENT
            PERMITTED BY APPLICABLE LAW. EXCEPT WHEN OTHERWISE STATED IN WRITING
            THE COPYRIGHT HOLDERS AND/OR OTHER PARTIES PROVIDE THE PROGRAM "AS
            IS" WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESSED OR IMPLIED,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE. THE ENTIRE
            RISK AS TO THE QUALITY AND PERFORMANCE OF THE PROGRAM IS WITH YOU.
            SHOULD THE PROGRAM PROVE DEFECTIVE, YOU ASSUME THE COST OF ALL
            NECESSARY SERVICING, REPAIR OR CORRECTION. 16. Limitation of
            Liability. IN NO EVENT UNLESS REQUIRED BY APPLICABLE LAW OR AGREED
            TO IN WRITING WILL ANY COPYRIGHT HOLDER, OR ANY OTHER PARTY WHO
            MODIFIES AND/OR CONVEYS THE PROGRAM AS PERMITTED ABOVE, BE LIABLE TO
            YOU FOR DAMAGES, INCLUDING ANY GENERAL, SPECIAL, INCIDENTAL OR
            CONSEQUENTIAL DAMAGES ARISING OUT OF THE USE OR INABILITY TO USE THE
            PROGRAM (INCLUDING BUT NOT LIMITED TO LOSS OF DATA OR DATA BEING
            RENDERED INACCURATE OR LOSSES SUSTAINED BY YOU OR THIRD PARTIES OR A
            FAILURE OF THE PROGRAM TO OPERATE WITH ANY OTHER PROGRAMS), EVEN IF
            SUCH HOLDER OR OTHER PARTY HAS BEEN ADVISED OF THE POSSIBILITY OF
            SUCH DAMAGES. 17. Interpretation of Sections 15 and 16. If the
            disclaimer of warranty and limitation of liability provided above
            cannot be given local legal effect according to their terms,
            reviewing courts shall apply local law that most closely
            approximates an absolute waiver of all civil liability in connection
            with the Program, unless a warranty or assumption of liability
            accompanies a copy of the Program in return for a fee.
          </td>
          <td></td>
        </tr>
        <tr>
          <td>Drivers</td>
          <td></td>
          <td>Apache License v2.0</td>
          <td>
            Apache License Version 2.0, January 2004
            http://www.apache.org/licenses/ TERMS AND CONDITIONS FOR USE,
            REPRODUCTION, AND DISTRIBUTION 1. Definitions. "License" shall mean
            the terms and conditions for use, reproduction, and distribution as
            defined by Sections 1 through 9 of this document. "Licensor" shall
            mean the copyright owner or entity authorized by the copyright owner
            that is granting the License. "Legal Entity" shall mean the union of
            the acting entity and all other entities that control, are
            controlled by, or are under common control with that entity. For the
            purposes of this definition, "control" means (i) the power, direct
            or indirect, to cause the direction or management of such entity,
            whether by contract or otherwise, or (ii) ownership of fifty percent
            (50%) or more of the outstanding shares, or (iii) beneficial
            ownership of such entity. "You" (or "Your") shall mean an individual
            or Legal Entity exercising permissions granted by this License.
            "Source" form shall mean the preferred form for making
            modifications, including but not limited to software source code,
            documentation source, and configuration files. "Object" form shall
            mean any form resulting from mechanical transformation or
            translation of a Source form, including but not limited to compiled
            object code, generated documentation, and conversions to other media
            types. "Work" shall mean the work of authorship, whether in Source
            or Object form, made available under the License, as indicated by a
            copyright notice that is included in or attached to the work (an
            example is provided in the Appendix below). "Derivative Works" shall
            mean any work, whether in Source or Object form, that is based on
            (or derived from) the Work and for which the editorial revisions,
            annotations, elaborations, or other modifications represent, as a
            whole, an original work of authorship. For the purposes of this
            License, Derivative Works shall not include works that remain
            separable from, or merely link (or bind by name) to the interfaces
            of, the Work and Derivative Works thereof. "Contribution" shall mean
            any work of authorship, including the original version of the Work
            and any modifications or additions to that Work or Derivative Works
            thereof, that is intentionally submitted to Licensor for inclusion
            in the Work by the copyright owner or by an individual or Legal
            Entity authorized to submit on behalf of the copyright owner. For
            the purposes of this definition, "submitted" means any form of
            electronic, verbal, or written communication sent to the Licensor or
            its representatives, including but not limited to communication on
            electronic mailing lists, source code control systems, and issue
            tracking systems that are managed by, or on behalf of, the Licensor
            for the purpose of discussing and improving the Work, but excluding
            communication that is conspicuously marked or otherwise designated
            in writing by the copyright owner as "Not a Contribution."
            "Contributor" shall mean Licensor and any individual or Legal Entity
            on behalf of whom a Contribution has been received by Licensor and
            subsequently incorporated within the Work. 2. Grant of Copyright
            License. Subject to the terms and conditions of this License, each
            Contributor hereby grants to You a perpetual, worldwide,
            non-exclusive, no-charge, royalty-free, irrevocable copyright
            license to reproduce, prepare Derivative Works of, publicly display,
            publicly perform, sublicense, and distribute the Work and such
            Derivative Works in Source or Object form. 3. Grant of Patent
            License. Subject to the terms and conditions of this License, each
            Contributor hereby grants to You a perpetual, worldwide,
            non-exclusive, no-charge, royalty-free, irrevocable (except as
            stated in this section) patent license to make, have made, use,
            offer to sell, sell, import, and otherwise transfer the Work, where
            such license applies only to those patent claims licensable by such
            Contributor that are necessarily infringed by their Contribution(s)
            alone or by combination of their Contribution(s) with the Work to
            which such Contribution(s) was submitted. If You institute patent
            litigation against any entity (including a cross-claim or
            counterclaim in a lawsuit) alleging that the Work or a Contribution
            incorporated within the Work constitutes direct or contributory
            patent infringement, then any patent licenses granted to You under
            this License for that Work shall terminate as of the date such
            litigation is filed. 4. Redistribution. You may reproduce and
            distribute copies of the Work or Derivative Works thereof in any
            medium, with or without modifications, and in Source or Object form,
            provided that You meet the following conditions: (a) You must give
            any other recipients of the Work or Derivative Works a copy of this
            License; and (b) You must cause any modified files to carry
            prominent notices stating that You changed the files; and (c) You
            must retain, in the Source form of any Derivative Works that You
            distribute, all copyright, patent, trademark, and attribution
            notices from the Source form of the Work, excluding those notices
            that do not pertain to any part of the Derivative Works; and (d) If
            the Work includes a "NOTICE" text file as part of its distribution,
            then any Derivative Works that You distribute must include a
            readable copy of the attribution notices contained within such
            NOTICE file, excluding those notices that do not pertain to any part
            of the Derivative Works, in at least one of the following places:
            within a NOTICE text file distributed as part of the Derivative
            Works; within the Source form or documentation, if provided along
            with the Derivative Works; or, within a display generated by the
            Derivative Works, if and wherever such third-party notices normally
            appear. The contents of the NOTICE file are for informational
            purposes only and do not modify the License. You may add Your own
            attribution notices within Derivative Works that You distribute,
            alongside or as an addendum to the NOTICE text from the Work,
            provided that such additional attribution notices cannot be
            construed as modifying the License. You may add Your own copyright
            statement to Your modifications and may provide additional or
            different license terms and conditions for use, reproduction, or
            distribution of Your modifications, or for any such Derivative Works
            as a whole, provided Your use, reproduction, and distribution of the
            Work otherwise complies with the conditions stated in this License.
            5. Submission of Contributions. Unless You explicitly state
            otherwise, any Contribution intentionally submitted for inclusion in
            the Work by You to the Licensor shall be under the terms and
            conditions of this License, without any additional terms or
            conditions. Notwithstanding the above, nothing herein shall
            supersede or modify the terms of any separate license agreement you
            may have executed with Licensor regarding such Contributions. 6.
            Trademarks. This License does not grant permission to use the trade
            names, trademarks, service marks, or product names of the Licensor,
            except as required for reasonable and customary use in describing
            the origin of the Work and reproducing the content of the NOTICE
            file. 7. Disclaimer of Warranty. Unless required by applicable law
            or agreed to in writing, Licensor provides the Work (and each
            Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT
            WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied,
            including, without limitation, any warranties or conditions of
            TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A
            PARTICULAR PURPOSE. You are solely responsible for determining the
            appropriateness of using or redistributing the Work and assume any
            risks associated with Your exercise of permissions under this
            License. 8. Limitation of Liability. In no event and under no legal
            theory, whether in tort (including negligence), contract, or
            otherwise, unless required by applicable law (such as deliberate and
            grossly negligent acts) or agreed to in writing, shall any
            Contributor be liable to You for damages, including any direct,
            indirect, special, incidental, or consequential damages of any
            character arising as a result of this License or out of the use or
            inability to use the Work (including but not limited to damages for
            loss of goodwill, work stoppage, computer failure or malfunction, or
            any and all other commercial damages or losses), even if such
            Contributor has been advised of the possibility of such damages. 9.
            Accepting Warranty or Additional Liability. While redistributing the
            Work or Derivative Works thereof, You may choose to offer, and
            charge a fee for, acceptance of support, warranty, indemnity, or
            other liability obligations and/or rights consistent with this
            License. However, in accepting such obligations, You may act only on
            Your own behalf and on Your sole responsibility, not on behalf of
            any other Contributor, and only if You agree to indemnify, defend,
            and hold each Contributor harmless for any liability incurred by, or
            claims asserted against, such Contributor by reason of your
            accepting any such warranty or additional liability. END OF TERMS
            AND CONDITIONS APPENDIX: How to apply the Apache License to your
            work. To apply the Apache License to your work, attach the following
            boilerplate notice, with the fields enclosed by brackets "[]"
            replaced with your own identifying information. (Don't include the
            brackets!) The text should be enclosed in the appropriate comment
            syntax for the file format. We also recommend that a file or class
            name and description of purpose be included on the same "printed
            page" as the copyright notice for easier identification within
            third-party archives. Copyright [yyyy] [name of copyright owner]
            Licensed under the Apache License, Version 2.0 (the "License"); you
            may not use this file except in compliance with the License. You may
            obtain a copy of the License at
            http://www.apache.org/licenses/LICENSE-2.0 Unless required by
            applicable law or agreed to in writing, software distributed under
            the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES
            OR CONDITIONS OF ANY KIND, either express or implied. See the
            License for the specific language governing permissions and
            limitations under the License.
          </td>
          <td></td>
        </tr>

        {/* Webserver License */}
        <tr>
          <td>nginx</td>
          <td>1.17.6</td>
          <td>BSD 2-Clause "Simplified" License</td>
          <td>
            Copyright (C) 2011-2016 Nginx, Inc. All rights reserved.
            Redistribution and use in source and binary forms, with or without
            modification, are permitted provided that the following conditions
            are met: 1. Redistributions of source code must retain the above
            copyright notice, this list of conditions and the following
            disclaimer. 2. Redistributions in binary form must reproduce the
            above copyright notice, this list of conditions and the following
            disclaimer in the documentation and/or other materials provided with
            the distribution. THIS SOFTWARE IS PROVIDED BY THE AUTHOR AND
            CONTRIBUTORS ``AS IS'' AND ANY EXPRESS OR IMPLIED WARRANTIES,
            INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF
            MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
            IN NO EVENT SHALL THE AUTHOR OR CONTRIBUTORS BE LIABLE FOR ANY
            DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
            DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE
            GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
            INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER
            IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
            OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN
            IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
          </td>
          <td>https://github.com/nginxinc/docker-nginx/tree/1.17.6</td>
        </tr>
        <tr>
          <td>OpenSSL</td>
          <td>1.1.1</td>
          <td>OpenSSL License</td>
          <td>
            LICENSE ISSUES ============== The OpenSSL toolkit stays under a
            double license, i.e. both the conditions of the OpenSSL License and
            the original SSLeay license apply to the toolkit. See below for the
            actual license texts. OpenSSL License --------------- /*
            ====================================================================
            * Copyright (c) 1998-2019 The OpenSSL Project. All rights reserved.
            * * Redistribution and use in source and binary forms, with or
            without * modification, are permitted provided that the following
            conditions * are met: * * 1. Redistributions of source code must
            retain the above copyright * notice, this list of conditions and the
            following disclaimer. * * 2. Redistributions in binary form must
            reproduce the above copyright * notice, this list of conditions and
            the following disclaimer in * the documentation and/or other
            materials provided with the * distribution. * * 3. All advertising
            materials mentioning features or use of this * software must display
            the following acknowledgment: * "This product includes software
            developed by the OpenSSL Project * for use in the OpenSSL Toolkit.
            (http://www.openssl.org/)" * * 4. The names "OpenSSL Toolkit" and
            "OpenSSL Project" must not be used to * endorse or promote products
            derived from this software without * prior written permission. For
            written permission, please contact * openssl-core@openssl.org. * *
            5. Products derived from this software may not be called "OpenSSL" *
            nor may "OpenSSL" appear in their names without prior written *
            permission of the OpenSSL Project. * * 6. Redistributions of any
            form whatsoever must retain the following * acknowledgment: * "This
            product includes software developed by the OpenSSL Project * for use
            in the OpenSSL Toolkit (http://www.openssl.org/)" * * THIS SOFTWARE
            IS PROVIDED BY THE OpenSSL PROJECT ``AS IS'' AND ANY * EXPRESSED OR
            IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE * IMPLIED
            WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR * PURPOSE
            ARE DISCLAIMED. IN NO EVENT SHALL THE OpenSSL PROJECT OR * ITS
            CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, *
            SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT * NOT
            LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; * LOSS OF
            USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) * HOWEVER CAUSED
            AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, * STRICT
            LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) * ARISING IN
            ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED * OF THE
            POSSIBILITY OF SUCH DAMAGE. *
            ====================================================================
            * * This product includes cryptographic software written by Eric
            Young * (eay@cryptsoft.com). This product includes software written
            by Tim * Hudson (tjh@cryptsoft.com). * */ Original SSLeay License
            ----------------------- /* Copyright (C) 1995-1998 Eric Young
            (eay@cryptsoft.com) * All rights reserved. * * This package is an
            SSL implementation written * by Eric Young (eay@cryptsoft.com). *
            The implementation was written so as to conform with Netscapes SSL.
            * * This library is free for commercial and non-commercial use as
            long as * the following conditions are aheared to. The following
            conditions * apply to all code found in this distribution, be it the
            RC4, RSA, * lhash, DES, etc., code; not just the SSL code. The SSL
            documentation * included with this distribution is covered by the
            same copyright terms * except that the holder is Tim Hudson
            (tjh@cryptsoft.com). * * Copyright remains Eric Young's, and as such
            any Copyright notices in * the code are not to be removed. * If this
            package is used in a product, Eric Young should be given attribution
            * as the author of the parts of the library used. * This can be in
            the form of a textual message at program startup or * in
            documentation (online or textual) provided with the package. * *
            Redistribution and use in source and binary forms, with or without *
            modification, are permitted provided that the following conditions *
            are met: * 1. Redistributions of source code must retain the
            copyright * notice, this list of conditions and the following
            disclaimer. * 2. Redistributions in binary form must reproduce the
            above copyright * notice, this list of conditions and the following
            disclaimer in the * documentation and/or other materials provided
            with the distribution. * 3. All advertising materials mentioning
            features or use of this software * must display the following
            acknowledgement: * "This product includes cryptographic software
            written by * Eric Young (eay@cryptsoft.com)" * The word
            'cryptographic' can be left out if the rouines from the library *
            being used are not cryptographic related :-). * 4. If you include
            any Windows specific code (or a derivative thereof) from * the apps
            directory (application code) you must include an acknowledgement: *
            "This product includes software written by Tim Hudson
            (tjh@cryptsoft.com)" * * THIS SOFTWARE IS PROVIDED BY ERIC YOUNG
            ``AS IS'' AND * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT
            NOT LIMITED TO, THE * IMPLIED WARRANTIES OF MERCHANTABILITY AND
            FITNESS FOR A PARTICULAR PURPOSE * ARE DISCLAIMED. IN NO EVENT SHALL
            THE AUTHOR OR CONTRIBUTORS BE LIABLE * FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL * DAMAGES
            (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS * OR
            SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) *
            HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT,
            STRICT * LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
            ARISING IN ANY WAY * OUT OF THE USE OF THIS SOFTWARE, EVEN IF
            ADVISED OF THE POSSIBILITY OF * SUCH DAMAGE. * * The licence and
            distribution terms for any publically available version or *
            derivative of this code cannot be changed. i.e. this code cannot
            simply be * copied and put under another distribution licence *
            [including the GNU Public Licence.] */
          </td>
          <td>https://github.com/openssl/openssl/tree/OpenSSL_1_1_1-stable</td>
        </tr>
        <tr>
          <td>Zlib</td>
          <td>1.2.11</td>
          <td>zlib License</td>
          <td>
            zlib.h -- interface of the 'zlib' general purpose compression
            library version 1.2.11, January 15th, 2017 Copyright (C) 1995-2017
            Jean-loup Gailly and Mark Adler This software is provided 'as-is',
            without any express or implied warranty. In no event will the
            authors be held liable for any damages arising from the use of this
            software. Permission is granted to anyone to use this software for
            any purpose, including commercial applications, and to alter it and
            redistribute it freely, subject to the following restrictions: 1.
            The origin of this software must not be misrepresented; you must not
            claim that you wrote the original software. If you use this software
            in a product, an acknowledgment in the product documentation would
            be appreciated but is not required. 2. Altered source versions must
            be plainly marked as such, and must not be misrepresented as being
            the original software. 3. This notice may not be removed or altered
            from any source distribution. Jean-loup Gailly Mark Adler
            jloup@gzip.org madler@alumni.caltech.edu
          </td>
          <td>https://zlib.net/</td>
        </tr>
        <tr>
          <td>PCRE</td>
          <td>8.44</td>
          <td>Custom License and BSD 3-Clause "New" or "Revised" License</td>
          <td>
            PCRE LICENCE ------------ PCRE is a library of functions to support
            regular expressions whose syntax and semantics are as close as
            possible to those of the Perl 5 language. Release 8 of PCRE is
            distributed under the terms of the "BSD" licence, as specified
            below. The documentation for PCRE, supplied in the "doc" directory,
            is distributed under the same terms as the software itself. The data
            in the testdata directory is not copyrighted and is in the public
            domain. The basic library functions are written in C and are
            freestanding. Also included in the distribution is a set of C++
            wrapper functions, and a just-in-time compiler that can be used to
            optimize pattern matching. These are both optional features that can
            be omitted when the library is built. THE BASIC LIBRARY FUNCTIONS
            --------------------------- Written by: Philip Hazel Email local
            part: ph10 Email domain: cam.ac.uk University of Cambridge Computing
            Service, Cambridge, England. Copyright (c) 1997-2020 University of
            Cambridge All rights reserved. PCRE JUST-IN-TIME COMPILATION SUPPORT
            ------------------------------------- Written by: Zoltan Herczeg
            Email local part: hzmester Email domain: freemail.hu Copyright(c)
            2010-2020 Zoltan Herczeg All rights reserved. STACK-LESS
            JUST-IN-TIME COMPILER -------------------------------- Written by:
            Zoltan Herczeg Email local part: hzmester Email domain: freemail.hu
            Copyright(c) 2009-2020 Zoltan Herczeg All rights reserved. THE C++
            WRAPPER FUNCTIONS ------------------------- Contributed by: Google
            Inc. Copyright (c) 2007-2012, Google Inc. All rights reserved. THE
            "BSD" LICENCE ----------------- Redistribution and use in source and
            binary forms, with or without modification, are permitted provided
            that the following conditions are met: * Redistributions of source
            code must retain the above copyright notice, this list of conditions
            and the following disclaimer. * Redistributions in binary form must
            reproduce the above copyright notice, this list of conditions and
            the following disclaimer in the documentation and/or other materials
            provided with the distribution. * Neither the name of the University
            of Cambridge nor the name of Google Inc. nor the names of their
            contributors may be used to endorse or promote products derived from
            this software without specific prior written permission. THIS
            SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
            IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
            LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
            FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE
            COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT,
            INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
            BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
            LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
            CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT
            LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN
            ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGE. End
          </td>
          <td>https://sourceforge.net/projects/pcre/files/pcre/8.44/</td>
        </tr>
      </Table>
    </Container>
  );
};

export default LegalNotice;
